import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Unit_instanceat14thlj150z as Unit_instance,
  contentEquals2jbsaphs7gxql as contentEquals,
  contentHashCode33l4yznfe2pz3 as contentHashCode,
  intArrayIterator15bt84fheeonh as intArrayIterator,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  contentEquals379bkuxwxaiqz as contentEquals_0,
  contentHashCode2dpr73siofp13 as contentHashCode_0,
  floatArrayIteratortsocm2kbztk as floatArrayIterator,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  get_indices3jka924ymcx7p as get_indices,
  println2shhhgwwt4c61 as println,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  Long2qws0ah9gnpki as Long,
  toLongw1zpgk99d84b as toLong,
  reverse2o3etdk6ug8y7 as reverse,
  createThis2j2avj17cvnv2 as createThis,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isIntArrayeijsubfngq38 as isIntArray,
  copyOf3rutauicler23 as copyOf,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  take8rd02inxauy8 as take,
  equals2au1ep9vhcato as equals,
  KtList3hktaavzmj137 as KtList,
  isInterface3d6p8outrmvmk as isInterface,
  StringBuildermazzzhj6kkai as StringBuilder,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Collection1k04j3hzsbod0 as Collection,
  copyOfgossjg6lh6js as copyOf_0,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  takei63g8tyo7wy9 as take_0,
  asList2ho2pewtsfvv as asList,
  compareTo3ankvs086tmwq as compareTo,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  isArray1hxjqtqy632bc as isArray,
  toList3jhuyej2anx2q as toList,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  to2cs3ny02qtbcb as to,
  KtMap140uvy3s5zad8 as KtMap,
  hashCodeq5arwsb9dgti as hashCode,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  AbstractMutableSetthfi6jds1k2h as AbstractMutableSet,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  until1jbpn0z3f8lbg as until,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  joinToString1cxrrlmo0chqs as joinToString,
  Iterable1y3qizuf89iou as Iterable,
  copyOf2ng0t8oizk6it as copyOf_1,
  toString30pk9tzaqopn as toString_0,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  reversed3cb5fwpceefdb as reversed,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  toSet2orjxp16sotqu as toSet,
  contentEqualsaf55p28mnw74 as contentEquals_1,
  contentHashCode2i020q5tbeh2s as contentHashCode_1,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  getOrNull1go7ef9ldk0df as getOrNull,
  step18s9qzr5xwxat as step,
  arrayCopytctsywo3h7gj as arrayCopy,
  round2mrvepag8eey0 as round,
  toList383f556t1dixk as toList_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  _Int53Array___get_raw__impl__6kxpfy162bfaxaiidle as _Int53Array___get_raw__impl__6kxpfy,
  contentEquals3iwymudvpxgk as contentEquals_2,
  Companion_getInstance2fdy01ctwk4tu as Companion_getInstance,
  _Int53___init__impl__iowqng217zysgv5n7hi as _Int53___init__impl__iowqng,
  _Int53___get_value__impl__ww0yo3sycx74wn0sq7 as _Int53___get_value__impl__ww0yo,
  contentHashCodeszilr1s8tm6t as contentHashCode_2,
  Int53Array__iterator_impl_29xi4z2bmi7lcwkuzdi as Int53Array__iterator_impl_29xi4z,
  Int532aaztjxx675u5 as Int53,
  Int53__toString_impl_j0waj0366nerregb2yc as Int53__toString_impl_j0waj0,
  Companion_instance1818l4yj5cjpb as Companion_instance,
  _Int53Array___init__impl__gn3wej1wobb2eteq00p as _Int53Array___init__impl__gn3wej,
  Int53Array2e5awid9sqa75 as Int53Array,
} from './korlibs-number-root-korlibs-number.mjs';
import {
  ilog23dbvpk38jf7rc as ilog2,
  umod164hvijxhfi8p as umod,
  ilog2Ceil34a3ub1n8578t as ilog2Ceil,
  isAlmostEquals$default2ib7nwup21mfy as isAlmostEquals$default,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  listIterator247sl90ooi4qv as listIterator,
  DoubleList2honu8rif2roh as DoubleList,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  Mixin3lmkm5hum2vdj as Mixin,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
  Lock5n7hh3dgcidl as Lock,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  Vector2D378fe5rov8fgw as Vector2D,
  IDoubleVectorListoa05cse3he2p as IDoubleVectorList,
  IPointListz7raskb2mrxa as IPointList,
  isAlmostEquals2qd88bwpjj4z5 as isAlmostEquals,
  containsAll194lepx84fvib as containsAll,
  iterator1sm8hwbj0nmg8 as iterator,
  listIteratorrk3szyua4uzm as listIterator_0,
  listIterator3ooh2yjav3kr9 as listIterator_1,
  subList2funs4qwcrhhq as subList,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {}
class IArray2 {}
function inside(x, y) {
  return x >= 0 && y >= 0 && x < this.f3u() && y < this.g3u();
}
function getAt(x, y) {
  return this.n3u(x, y) ? this.x27(indexOr(this, x, y)) : this.x27(0);
}
function asString() {
  var tmp = until(0, this.g3u());
  return joinToString(tmp, '\n', VOID, VOID, VOID, VOID, IArray2$asString$lambda(this));
}
class IntIArray2 {}
function get(x, y) {
  return this.i3u(indexOr(this, x, y));
}
function set(x, y, value) {
  return this.j3u(indexOr(this, x, y), value);
}
function getAt_0(idx) {
  return this.i3u(idx);
}
class IntArray2 {
  constructor(width, height, data) {
    this.c3u_1 = width;
    this.d3u_1 = height;
    this.e3u_1 = data;
    Companion_instance_5.h3u(this.f3u(), this.g3u(), this.e3u_1.length);
  }
  f3u() {
    return this.c3u_1;
  }
  g3u() {
    return this.d3u_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof IntArray2) {
      tmp_1 = this.f3u() === other.f3u();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.g3u() === other.g3u();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.e3u_1, other.e3u_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  i3u(idx) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.e3u_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= idx ? idx <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[idx];
    } else {
      // Inline function 'korlibs.datastructure.IntArray2.getFast.<anonymous>' call
      tmp = this.e3u_1[0];
    }
    return tmp;
  }
  j3u(idx, value) {
    if (0 <= idx ? idx <= (this.e3u_1.length - 1 | 0) : false) {
      this.e3u_1[idx] = value;
    }
  }
  hashCode() {
    return (this.f3u() + this.g3u() | 0) + contentHashCode(this.e3u_1) | 0;
  }
  b1() {
    return intArrayIterator(this.e3u_1);
  }
  toString() {
    return this.k3u();
  }
}
class Companion_0 {}
class FloatIArray2 {}
function get_0(x, y) {
  return this.i3u(indexOr(this, x, y));
}
function set_0(x, y, value) {
  return this.r3u(indexOr(this, x, y), value);
}
function getAt_1(idx) {
  return this.i3u(idx);
}
class FloatArray2 {
  constructor(width, height, data) {
    this.o3u_1 = width;
    this.p3u_1 = height;
    this.q3u_1 = data;
    Companion_instance_5.h3u(this.f3u(), this.g3u(), this.q3u_1.length);
  }
  f3u() {
    return this.o3u_1;
  }
  g3u() {
    return this.p3u_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof FloatArray2) {
      tmp_1 = this.f3u() === other.f3u();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.g3u() === other.g3u();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals_0(this.q3u_1, other.q3u_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  i3u(idx) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.q3u_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= idx ? idx <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[idx];
    } else {
      // Inline function 'korlibs.datastructure.FloatArray2.getFast.<anonymous>' call
      tmp = 0.0;
    }
    return tmp;
  }
  r3u(idx, value) {
    if (0 <= idx ? idx <= (this.q3u_1.length - 1 | 0) : false) {
      this.q3u_1[idx] = value;
    }
  }
  hashCode() {
    return (this.f3u() + this.g3u() | 0) + contentHashCode_0(this.q3u_1) | 0;
  }
  b1() {
    return floatArrayIterator(this.q3u_1);
  }
  toString() {
    return this.k3u();
  }
}
class Companion_1 {}
class Int53IArray2 {}
function get_1(x, y) {
  return this.w3u(indexOr(this, x, y));
}
function set_1(x, y, value) {
  return this.x3u(indexOr(this, x, y), value);
}
function getAt_2(idx) {
  return this.w3u(idx);
}
class Int53Array2 {
  constructor(width, height, data) {
    this.t3u_1 = width;
    this.u3u_1 = height;
    this.v3u_1 = data;
    var tmp = Companion_instance_5;
    var tmp_0 = this.f3u();
    var tmp_1 = this.g3u();
    // Inline function 'korlibs.number.Int53Array.size' call
    var this_0 = this.v3u_1;
    var tmp$ret$0 = _Int53Array___get_raw__impl__6kxpfy(this_0).length;
    tmp.h3u(tmp_0, tmp_1, tmp$ret$0);
  }
  f3u() {
    return this.t3u_1;
  }
  g3u() {
    return this.u3u_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof Int53Array2) {
      tmp_1 = this.f3u() === other.f3u();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.g3u() === other.g3u();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals_2(this.v3u_1, other.v3u_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  w3u(idx) {
    // Inline function 'korlibs.number.getOrElse' call
    var this_0 = this.v3u_1;
    var tmp;
    // Inline function 'korlibs.number.Int53Array.indices' call
    var progression = get_indices(_Int53Array___get_raw__impl__6kxpfy(this_0));
    var containsLower = progression.f2_1;
    if (idx <= progression.g2_1 ? containsLower <= idx : false) {
      // Inline function 'korlibs.number.Int53Array.get' call
      tmp = _Int53___init__impl__iowqng(_Int53Array___get_raw__impl__6kxpfy(this_0)[idx]);
    } else {
      // Inline function 'korlibs.datastructure.Int53Array2.getFast.<anonymous>' call
      tmp = Companion_getInstance().t26_1;
    }
    return tmp;
  }
  x3u(idx, value) {
    var tmp;
    if (0 <= idx) {
      // Inline function 'korlibs.number.Int53Array.size' call
      var this_0 = this.v3u_1;
      tmp = idx < _Int53Array___get_raw__impl__6kxpfy(this_0).length;
    } else {
      tmp = false;
    }
    if (tmp) {
      // Inline function 'korlibs.number.Int53Array.set' call
      var this_1 = this.v3u_1;
      _Int53Array___get_raw__impl__6kxpfy(this_1)[idx] = _Int53___get_value__impl__ww0yo(value);
    }
  }
  hashCode() {
    return (this.f3u() + this.g3u() | 0) + contentHashCode_2(this.v3u_1) | 0;
  }
  b1() {
    return Int53Array__iterator_impl_29xi4z(this.v3u_1);
  }
  toString() {
    return this.k3u();
  }
  x27(idx) {
    return new Int53(this.a3v(idx));
  }
}
class ByteArrayDeque {
  constructor(initialBits, allowGrow) {
    initialBits = initialBits === VOID ? 10 : initialBits;
    allowGrow = allowGrow === VOID ? true : allowGrow;
    this.j3v_1 = initialBits;
    this.k3v_1 = allowGrow;
    this.l3v_1 = new RingBuffer(this.j3v_1);
    this.m3v_1 = new Int8Array(1024);
    this.n3v_1 = new Long(0, 0);
    this.o3v_1 = new Long(0, 0);
  }
  u2d() {
    return this.l3v_1.i3v_1;
  }
  v2d(buffer, offset, size) {
    ensureWrite(this, size);
    var out = this.l3v_1.v2d(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      tmp.n3v_1 = this.n3v_1.w3(toLong(out));
    }
    return out;
  }
  q3v(buffer, offset, size, $super) {
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? buffer.length - offset | 0 : size;
    return $super === VOID ? this.v2d(buffer, offset, size) : $super.v2d.call(this, buffer, offset, size);
  }
  k2e(count) {
    return this.l3v_1.k2e(count);
  }
  j2e(buffer, offset, size) {
    return this.l3v_1.j2e(buffer, offset, size);
  }
  h3() {
    this.l3v_1.h3();
  }
  hashCode() {
    return this.l3v_1.x2d();
  }
  equals(other) {
    var tmp;
    if (other instanceof ByteArrayDeque) {
      tmp = this.l3v_1.equals(other.l3v_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class ShortArrayDeque {
  constructor(initialBits) {
    initialBits = initialBits === VOID ? 10 : initialBits;
    this.a3w_1 = initialBits;
    this.b3w_1 = new ShortRingBuffer(this.a3w_1);
    this.c3w_1 = new Int16Array(1024);
    this.d3w_1 = new Long(0, 0);
    this.e3w_1 = new Long(0, 0);
  }
  u2d() {
    return this.b3w_1.y3v_1;
  }
  g3w(buffer, offset, size) {
    var out = ensureWrite_0(this, size).b3w_1.g3w(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      tmp.d3w_1 = this.d3w_1.w3(toLong(out));
    }
    return out;
  }
  f3w(buffer, offset, size) {
    var out = this.b3w_1.f3w(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      tmp.e3w_1 = this.e3w_1.w3(toLong(out));
    }
    return out;
  }
  h3() {
    this.b3w_1.h3();
  }
  h3w() {
    this.f3w(this.c3w_1, 0, 1);
    return this.c3w_1[0];
  }
  i3w(value) {
    this.c3w_1[0] = value;
    this.g3w(this.c3w_1, 0, 1);
  }
  hashCode() {
    return this.b3w_1.x2d();
  }
  equals(other) {
    var tmp;
    if (other instanceof ShortArrayDeque) {
      tmp = this.b3w_1.equals(other.b3w_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class Companion_2 {}
class IntArrayList {
  static l3w(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Int32Array(capacity);
    tmp.j3w_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.k3w_1 = 0;
    return $this;
  }
  r22(value) {
    this.m3w(value);
    this.k3w_1 = value;
  }
  g1() {
    return this.k3w_1;
  }
  static n3w(other) {
    var $this = this.l3w();
    $this.o3w(other);
    return $this;
  }
  static p3w(other) {
    var $this = this.l3w();
    $this.q3w(other);
    return $this;
  }
  m3w(count) {
    if ((this.k3w_1 + count | 0) > this.j3w_1.length) {
      var tmp = this;
      var tmp_0 = this.j3w_1;
      // Inline function 'kotlin.math.max' call
      var a = this.k3w_1 + count | 0;
      var b = imul(this.j3w_1.length, 3);
      var tmp$ret$0 = Math.max(a, b);
      var tmp_1 = copyOf(tmp_0, tmp$ret$0);
      tmp.j3w_1 = isIntArray(tmp_1) ? tmp_1 : THROW_CCE();
    }
  }
  h3() {
    this.k3w_1 = 0;
  }
  r3w(v0) {
    this.m3w(1);
    var tmp = this.j3w_1;
    var _unary__edvuaz = this.k3w_1;
    this.k3w_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
  }
  s3w(value) {
    return this.r3w(value);
  }
  t3w(value) {
    return this.o3w(value);
  }
  u3w(values, offset, length) {
    this.m3w(length);
    var tmp = Memory_instance;
    tmp.v3w(isIntArray(values) ? values : THROW_CCE(), offset, this.j3w_1, this.g1(), length);
    this.r22(this.g1() + length | 0);
  }
  q3w(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.u3w(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.u3w.call(this, values, offset, length);
    }
    return tmp;
  }
  o3w(values) {
    return this.u3w(values.j3w_1, 0, values.g1());
  }
  h1(index) {
    return this.j3w_1[index];
  }
  x27(index) {
    return this.j3w_1[index];
  }
  w3w(index, value) {
    if (index >= this.k3w_1) {
      this.m3w(index + 1 | 0);
      this.k3w_1 = index + 1 | 0;
    }
    this.j3w_1[index] = value;
  }
  b1() {
    return this.k1(0);
  }
  hq(element) {
    var inductionVariable = 0;
    var last = this.k3w_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.j3w_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  x3w(elements) {
    var _iterator__ex2g4s = elements.b1();
    while (_iterator__ex2g4s.c1()) {
      var e = _iterator__ex2g4s.d1();
      if (!this.hq(e))
        return false;
    }
    return true;
  }
  a3(elements) {
    return this.x3w(elements);
  }
  j1() {
    return this.g1() === 0;
  }
  d1t() {
    return !(this.g1() === 0);
  }
  ml() {
    var tmp;
    if (this.j1()) {
      throw IndexOutOfBoundsException.ye();
    } else {
      tmp = this.j3w_1[0];
    }
    return tmp;
  }
  y3w() {
    var tmp;
    if (this.j1()) {
      throw IndexOutOfBoundsException.ye();
    } else {
      tmp = this.j3w_1[this.k3w_1 - 1 | 0];
    }
    return tmp;
  }
  z3w(index, value) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntArrayList.insertAt.<anonymous>' call
    this.m3w(1);
    if (this.d1t()) {
      Memory_instance.v3w(this.j3w_1, index, this.j3w_1, index + 1 | 0, this.k3w_1 - index | 0);
    }
    this.j3w_1[index] = value;
    this.k3w_1 = this.k3w_1 + 1 | 0;
    return this;
  }
  a3x(indexA, indexB) {
    var l = this.x27(indexA);
    var r = this.x27(indexB);
    this.w3w(indexA, r);
    this.w3w(indexB, l);
  }
  b3x(index, count) {
    if (index < 0 || index >= this.k3w_1 || (index + count | 0) > this.k3w_1)
      throw IndexOutOfBoundsException.ye();
    var out = this.j3w_1[index];
    if (count > 0) {
      if (index < (this.k3w_1 - count | 0)) {
        Memory_instance.v3w(this.j3w_1, index + count | 0, this.j3w_1, index, (this.k3w_1 - index | 0) - count | 0);
      }
      this.k3w_1 = this.k3w_1 - count | 0;
    }
    return out;
  }
  c3x() {
    return copyOf(this.j3w_1, this.k3w_1);
  }
  k1(index) {
    return take(this.j3w_1, this.k3w_1).k1(index);
  }
  hashCode() {
    return contentHashCode_3(this.j3w_1, 0, this.g1());
  }
  equals(other) {
    if (other instanceof IntArrayList)
      return this.g1() === other.g1() && contentEquals_3(this.j3w_1, other.j3w_1, 0, this.g1());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.mc(2 + imul(5, this.g1()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntArrayList.toString.<anonymous>' call
    this_0.hc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.gc(', ');
        }
        this_0.rh(this.x27(n));
      }
       while (inductionVariable < last);
    this_0.hc(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class Companion_3 {}
class DoubleArrayList {
  static f3x(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Float64Array(capacity);
    tmp.d3x_1 = isDoubleArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.e3x_1 = 0;
    return $this;
  }
  r22(value) {
    ensure(this, value);
    this.e3x_1 = value;
  }
  g1() {
    return this.e3x_1;
  }
  static g3x(other) {
    var $this = this.f3x();
    $this.h3x(other);
    return $this;
  }
  h3() {
    this.e3x_1 = 0;
  }
  s29(v0) {
    ensure(this, 1);
    var tmp = this.d3x_1;
    var _unary__edvuaz = this.e3x_1;
    this.e3x_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
  }
  i3x(v0, v1) {
    ensure(this, 2);
    var tmp = this.d3x_1;
    var _unary__edvuaz = this.e3x_1;
    this.e3x_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.d3x_1;
    var _unary__edvuaz_0 = this.e3x_1;
    this.e3x_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
  }
  j3x(v0, v1, v2, v3) {
    ensure(this, 4);
    var tmp = this.d3x_1;
    var _unary__edvuaz = this.e3x_1;
    this.e3x_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.d3x_1;
    var _unary__edvuaz_0 = this.e3x_1;
    this.e3x_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.d3x_1;
    var _unary__edvuaz_1 = this.e3x_1;
    this.e3x_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.d3x_1;
    var _unary__edvuaz_2 = this.e3x_1;
    this.e3x_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
  }
  k3x(v0, v1, v2, v3, v4, v5) {
    ensure(this, 6);
    var tmp = this.d3x_1;
    var _unary__edvuaz = this.e3x_1;
    this.e3x_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.d3x_1;
    var _unary__edvuaz_0 = this.e3x_1;
    this.e3x_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.d3x_1;
    var _unary__edvuaz_1 = this.e3x_1;
    this.e3x_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.d3x_1;
    var _unary__edvuaz_2 = this.e3x_1;
    this.e3x_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
    var tmp_3 = this.d3x_1;
    var _unary__edvuaz_3 = this.e3x_1;
    this.e3x_1 = _unary__edvuaz_3 + 1 | 0;
    tmp_3[_unary__edvuaz_3] = v4;
    var tmp_4 = this.d3x_1;
    var _unary__edvuaz_4 = this.e3x_1;
    this.e3x_1 = _unary__edvuaz_4 + 1 | 0;
    tmp_4[_unary__edvuaz_4] = v5;
  }
  l3x(value) {
    return this.s29(value);
  }
  m3x(value) {
    return this.h3x(value);
  }
  n3x(values, offset, length) {
    ensure(this, length);
    var tmp = Memory_instance;
    tmp.o3x(isDoubleArray(values) ? values : THROW_CCE(), offset, this.d3x_1, this.g1(), length);
    this.r22(this.g1() + length | 0);
  }
  p3x(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.n3x(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.n3x.call(this, values, offset, length);
    }
    return tmp;
  }
  h3x(values) {
    return this.n3x(values.d3x_1, 0, values.g1());
  }
  h1(index) {
    return this.d3x_1[index];
  }
  x27(index) {
    return this.d3x_1[index];
  }
  q3x(index, value) {
    if (index >= this.e3x_1) {
      ensure(this, index + 1 | 0);
      this.e3x_1 = index + 1 | 0;
    }
    this.d3x_1[index] = value;
  }
  b1() {
    return this.k1(0);
  }
  r3x(element) {
    var inductionVariable = 0;
    var last = this.e3x_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.d3x_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  a28(elements) {
    var _iterator__ex2g4s = elements.b1();
    while (_iterator__ex2g4s.c1()) {
      var e = _iterator__ex2g4s.d1();
      if (!this.r3x(e))
        return false;
    }
    return true;
  }
  a3(elements) {
    return this.a28(elements);
  }
  j1() {
    return this.g1() === 0;
  }
  a3x(indexA, indexB) {
    var l = this.x27(indexA);
    var r = this.x27(indexB);
    this.q3x(indexA, r);
    this.q3x(indexB, l);
  }
  j3(index) {
    return this.b3x(index, 1);
  }
  b3x(index, count) {
    if (index < 0 || index >= this.e3x_1 || (index + count | 0) > this.e3x_1)
      throw IndexOutOfBoundsException.ye();
    var out = this.d3x_1[index];
    if (count > 0) {
      if (index < (this.e3x_1 - count | 0)) {
        Memory_instance.o3x(this.d3x_1, index + count | 0, this.d3x_1, index, (this.e3x_1 - index | 0) - count | 0);
      }
      this.e3x_1 = this.e3x_1 - count | 0;
    }
    return out;
  }
  y27() {
    return copyOf_0(this.d3x_1, this.e3x_1);
  }
  k1(index) {
    return take_0(this.d3x_1, this.e3x_1).k1(index);
  }
  q1(fromIndex, toIndex) {
    // Inline function 'kotlin.collections.asList' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.d3x_1;
    return asList(tmp$ret$1).q1(fromIndex, toIndex);
  }
  z27() {
    return DoubleArrayList.g3x(this);
  }
  hashCode() {
    return contentHashCode_4(this.d3x_1, 0, this.g1());
  }
  equals(other) {
    if (other instanceof DoubleArrayList)
      return this.g1() === other.g1() && contentEquals_4(this.d3x_1, other.d3x_1, 0, this.g1());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.mc(2 + imul(5, this.g1()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.DoubleArrayList.toString.<anonymous>' call
    this_0.hc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.gc(', ');
        }
        this_0.uh(this.x27(n));
      }
       while (inductionVariable < last);
    this_0.hc(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class SortOps {
  x3x(subject, indexL, indexR) {
    var inductionVariable = indexR;
    var last = indexL + 1 | 0;
    if (last <= inductionVariable)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        this.w3x(subject, n - 1 | 0, n);
      }
       while (!(n === last));
  }
  s3x(subject, indexL, indexR) {
    var count = (indexR - indexL | 0) + 1 | 0;
    var inductionVariable = 0;
    var last = count / 2 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.w3x(subject, indexL + n | 0, indexR - n | 0);
      }
       while (inductionVariable < last);
  }
}
class DoubleArrayListSortOps extends SortOps {
  constructor() {
    DoubleArrayListSortOps_instance = null;
    super();
    DoubleArrayListSortOps_instance = this;
  }
  t3x(subject, l, r) {
    return compareTo(subject.x27(l), subject.x27(r));
  }
  u3x(subject, l, r) {
    return this.t3x(subject instanceof DoubleArrayList ? subject : THROW_CCE(), l, r);
  }
  v3x(subject, indexL, indexR) {
    var l = subject.x27(indexL);
    var r = subject.x27(indexR);
    subject.q3x(indexR, l);
    subject.q3x(indexL, r);
  }
  w3x(subject, indexL, indexR) {
    return this.v3x(subject instanceof DoubleArrayList ? subject : THROW_CCE(), indexL, indexR);
  }
}
class TGenDeque$iterator$1 {
  constructor($that, this$0) {
    this.d3y_1 = $that;
    this.e3y_1 = this$0;
    this.c3y_1 = 0;
  }
  d1() {
    var _unary__edvuaz = this.c3y_1;
    this.c3y_1 = _unary__edvuaz + 1 | 0;
    return this.d3y_1.h1(_unary__edvuaz);
  }
  c1() {
    return this.c3y_1 < this.e3y_1.g1();
  }
  t6() {
    this.c3y_1 = this.c3y_1 - 1 | 0;
    this.e3y_1.j3(this.c3y_1);
  }
}
class TGenDeque {
  static f3y(initialCapacity) {
    var $this = createThis(this);
    $this.y3x_1 = 0;
    $this.z3x_1 = 0;
    var tmp = $this;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = fillArrayVal(Array(initialCapacity), null);
    tmp.a3y_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    return $this;
  }
  static g3y() {
    return this.f3y(16);
  }
  g1() {
    return this.z3x_1;
  }
  j1() {
    return this.g1() === 0;
  }
  h3y(item) {
    resizeIfRequiredFor(this, 1);
    _addLast(this, item);
  }
  i3y(item) {
    resizeIfRequiredFor(this, 1);
    this.y3x_1 = umod(this.y3x_1 - 1 | 0, _get_capacity__a9k9f3(this));
    this.z3x_1 = this.z3x_1 + 1 | 0;
    this.a3y_1[this.y3x_1] = item;
  }
  j3y(list) {
    // Inline function 'korlibs.datastructure.TGenDeque._addAll' call
    var count = list.g1();
    resizeIfRequiredFor(this, count);
    var base = this.y3x_1 + this.z3x_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.a3y_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3(this) | 0;
        // Inline function 'korlibs.datastructure.TGenDeque.addAll.<anonymous>' call
        tmp[tmp_0] = list.h1(n);
      }
       while (inductionVariable < count);
    this.z3x_1 = this.z3x_1 + count | 0;
    return true;
  }
  k3y(elements) {
    return this.j3y(toList(elements));
  }
  i1(elements) {
    return this.k3y(elements);
  }
  l3y(items) {
    // Inline function 'korlibs.datastructure.TGenDeque._addAllFirst' call
    var count = items.g1();
    resizeIfRequiredFor(this, count);
    this.y3x_1 = umod(this.y3x_1 - count | 0, _get_capacity__a9k9f3(this));
    this.z3x_1 = this.z3x_1 + count | 0;
    var pos = this.y3x_1;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.a3y_1;
        var _unary__edvuaz = pos;
        pos = _unary__edvuaz + 1 | 0;
        var tmp_0 = umod(_unary__edvuaz, _get_capacity__a9k9f3(this));
        // Inline function 'korlibs.datastructure.TGenDeque.addAllFirst.<anonymous>' call
        tmp[tmp_0] = items.h1(n);
      }
       while (inductionVariable < count);
    return true;
  }
  ql() {
    if (this.z3x_1 <= 0)
      throw IndexOutOfBoundsException.ye();
    var out = this.m3y();
    nullify(this, this.y3x_1);
    this.y3x_1 = (this.y3x_1 + 1 | 0) % _get_capacity__a9k9f3(this) | 0;
    this.z3x_1 = this.z3x_1 - 1 | 0;
    return out;
  }
  sl() {
    if (this.z3x_1 <= 0)
      throw IndexOutOfBoundsException.ye();
    var out = this.n3y();
    nullify(this, internalIndex(this, this.g1() - 1 | 0));
    this.z3x_1 = this.z3x_1 - 1 | 0;
    return out;
  }
  j3(index) {
    if (index < 0 || index >= this.g1())
      throw IndexOutOfBoundsException.ye();
    if (index === 0)
      return this.ql();
    if (index === (this.g1() - 1 | 0))
      return this.sl();
    var old = this.h1(index);
    if (index < (this.g1() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.o3y(n, this.h1(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.y3x_1 = umod(this.y3x_1 + 1 | 0, _get_capacity__a9k9f3(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.g1() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.o3y(n_0, this.h1(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    this.z3x_1 = this.z3x_1 - 1 | 0;
    return old;
  }
  p3y(element) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.TGenDeque.add.<anonymous>' call
    this.h3y(element);
    return true;
  }
  h(element) {
    return this.p3y((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  q3y(element) {
    var index = this.r3y(element);
    if (index >= 0) {
      this.j3(index);
    }
    return index >= 0;
  }
  g3(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.q3y((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  m3y() {
    return this.a3y_1[this.y3x_1];
  }
  n3y() {
    return this.a3y_1[internalIndex(this, this.g1() - 1 | 0)];
  }
  o3y(index, value) {
    this.a3y_1[internalIndex(this, index)] = value;
  }
  h1(index) {
    return this.a3y_1[internalIndex(this, index)];
  }
  r3y(element) {
    var inductionVariable = 0;
    var last = this.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.h1(n), element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  s3y(elements) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator = elements.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.datastructure.TGenDeque.containsAll.<anonymous>' call
      var tmp$ret$0 = to(item, 0);
      destination.h(tmp$ret$0);
    }
    var emap = toLinkedMap_0(destination);
    var inductionVariable = 0;
    var last = this.g1();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.h1(it);
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        if ((isInterface(emap, KtMap) ? emap : THROW_CCE()).c3(e)) {
          // Inline function 'kotlin.collections.set' call
          emap.k3(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = emap.n3();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.j1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator_0 = this_0.b1();
      while (tmp0_iterator_0.c1()) {
        var element = tmp0_iterator_0.d1();
        // Inline function 'korlibs.datastructure.TGenDeque.containsAll.<anonymous>' call
        if (!(element === 1)) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    return tmp$ret$5;
  }
  a3(elements) {
    return this.s3y(elements);
  }
  b1() {
    var that = this;
    return new TGenDeque$iterator$1(that, this);
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var size = this.g1();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        // Inline function 'korlibs.datastructure.TGenDeque.hashCode.<anonymous>' call
        var tmp0_safe_receiver = this.h1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < size);
    return result;
  }
  equals(other) {
    if (!(other instanceof TGenDeque))
      return false;
    if (!(other.g1() === this.g1()))
      return false;
    var inductionVariable = 0;
    var last = this.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(this.h1(n), other.h1(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  }
  toString() {
    var sb = StringBuilder.f();
    sb.hc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.fc(this.h1(n));
        if (!(n === (this.g1() - 1 | 0))) {
          sb.gc(', ');
        }
      }
       while (inductionVariable < last);
    sb.hc(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
class IntDeque$iterator$1 {
  constructor($that, this$0) {
    this.x3y_1 = $that;
    this.y3y_1 = this$0;
    this.w3y_1 = 0;
  }
  d1() {
    var _unary__edvuaz = this.w3y_1;
    this.w3y_1 = _unary__edvuaz + 1 | 0;
    return this.x3y_1.h1(_unary__edvuaz);
  }
  c1() {
    return this.w3y_1 < this.y3y_1.g1();
  }
  t6() {
    this.w3y_1 = this.w3y_1 - 1 | 0;
    this.y3y_1.j3(this.w3y_1);
  }
}
class IntDeque {
  static z3y(initialCapacity) {
    var $this = createThis(this);
    $this.t3y_1 = 0;
    $this.u3y_1 = 0;
    var tmp = $this;
    var tmp_0 = new Int32Array(initialCapacity);
    tmp.v3y_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    return $this;
  }
  static a3z() {
    return this.z3y(16);
  }
  g1() {
    return this.u3y_1;
  }
  j1() {
    return this.g1() === 0;
  }
  b3z(item) {
    resizeIfRequiredFor_0(this, 1);
    _addLast_0(this, item);
  }
  c3z(list) {
    // Inline function 'korlibs.datastructure.IntDeque._addAll' call
    var count = list.g1();
    resizeIfRequiredFor_0(this, count);
    var base = this.t3y_1 + this.u3y_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.v3y_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3_0(this) | 0;
        // Inline function 'korlibs.datastructure.IntDeque.addAll.<anonymous>' call
        tmp[tmp_0] = list.h1(n);
      }
       while (inductionVariable < count);
    this.u3y_1 = this.u3y_1 + count | 0;
    return true;
  }
  d3z(elements) {
    return this.c3z(toList(elements));
  }
  i1(elements) {
    return this.d3z(elements);
  }
  ql() {
    if (this.u3y_1 <= 0)
      throw IndexOutOfBoundsException.ye();
    var out = this.m3y();
    nullify_0(this, this.t3y_1);
    this.t3y_1 = (this.t3y_1 + 1 | 0) % _get_capacity__a9k9f3_0(this) | 0;
    this.u3y_1 = this.u3y_1 - 1 | 0;
    return out;
  }
  sl() {
    if (this.u3y_1 <= 0)
      throw IndexOutOfBoundsException.ye();
    var out = this.n3y();
    nullify_0(this, internalIndex_0(this, this.g1() - 1 | 0));
    this.u3y_1 = this.u3y_1 - 1 | 0;
    return out;
  }
  j3(index) {
    if (index < 0 || index >= this.g1())
      throw IndexOutOfBoundsException.ye();
    if (index === 0)
      return this.ql();
    if (index === (this.g1() - 1 | 0))
      return this.sl();
    var old = this.h1(index);
    if (index < (this.g1() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.w3w(n, this.h1(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.t3y_1 = umod(this.t3y_1 + 1 | 0, _get_capacity__a9k9f3_0(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.g1() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.w3w(n_0, this.h1(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    this.u3y_1 = this.u3y_1 - 1 | 0;
    return old;
  }
  e3z(element) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntDeque.add.<anonymous>' call
    this.b3z(element);
    return true;
  }
  h(element) {
    return this.e3z((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  f3z(element) {
    var index = this.g3z(element);
    if (index >= 0) {
      this.j3(index);
    }
    return index >= 0;
  }
  g3(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.f3z((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  m3y() {
    return this.v3y_1[this.t3y_1];
  }
  n3y() {
    return this.v3y_1[internalIndex_0(this, this.g1() - 1 | 0)];
  }
  w3w(index, value) {
    this.v3y_1[internalIndex_0(this, index)] = value;
  }
  h1(index) {
    return this.v3y_1[internalIndex_0(this, index)];
  }
  g3z(element) {
    var inductionVariable = 0;
    var last = this.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.h1(n) === element)
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  x3w(elements) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator = elements.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.datastructure.IntDeque.containsAll.<anonymous>' call
      var tmp$ret$0 = to(item, 0);
      destination.h(tmp$ret$0);
    }
    var emap = toLinkedMap_0(destination);
    var inductionVariable = 0;
    var last = this.g1();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.h1(it);
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        if ((isInterface(emap, KtMap) ? emap : THROW_CCE()).c3(e)) {
          // Inline function 'kotlin.collections.set' call
          emap.k3(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = emap.n3();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.j1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator_0 = this_0.b1();
      while (tmp0_iterator_0.c1()) {
        var element = tmp0_iterator_0.d1();
        // Inline function 'korlibs.datastructure.IntDeque.containsAll.<anonymous>' call
        if (!(element === 1)) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    return tmp$ret$5;
  }
  a3(elements) {
    return this.x3w(elements);
  }
  b1() {
    var that = this;
    return new IntDeque$iterator$1(that, this);
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var size = this.g1();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        // Inline function 'korlibs.datastructure.IntDeque.hashCode.<anonymous>' call
        var tmp0_safe_receiver = this.h1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < size);
    return result;
  }
  equals(other) {
    if (!(other instanceof IntDeque))
      return false;
    if (!(other.g1() === this.g1()))
      return false;
    var inductionVariable = 0;
    var last = this.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.h1(n) === other.h1(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  }
  toString() {
    var sb = StringBuilder.f();
    sb.hc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.rh(this.h1(n));
        if (!(n === (this.g1() - 1 | 0))) {
          sb.gc(', ');
        }
      }
       while (inductionVariable < last);
    sb.hc(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
class FastIdentityCacheMap {
  constructor() {
    this.h3z_1 = null;
    this.i3z_1 = null;
    this.j3z_1 = null;
    this.k3z_1 = null;
    this.l3z_1 = FastIdentityMap();
  }
  h3() {
    this.m3z();
    clear(this.l3z_1);
  }
  m3z() {
    this.h3z_1 = null;
    this.i3z_1 = null;
    this.j3z_1 = null;
    this.k3z_1 = null;
  }
}
class FastSmallSet extends AbstractMutableSet {
  static r3z() {
    var $this = this.i8();
    $this.n3z_1 = LinkedHashSet.r1();
    $this.o3z_1 = null;
    $this.p3z_1 = null;
    $this.q3z_1 = null;
    return $this;
  }
  g1() {
    return this.n3z_1.g1();
  }
  b1() {
    return this.n3z_1.b1();
  }
  s3z(element) {
    if (this.am(element))
      return false;
    this.n3z_1.h(element);
    return true;
  }
  h(element) {
    return this.s3z((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  t3z(element) {
    this.o3z_1 = null;
    this.p3z_1 = null;
    this.q3z_1 = null;
    this.n3z_1.g3(element);
    return true;
  }
  g3(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.t3z((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  am(element) {
    if (element === this.o3z_1 || element === this.p3z_1 || element === this.o3z_1)
      return true;
    var result = this.n3z_1.z2(element);
    if (result) {
      this.p3z_1 = this.o3z_1;
      this.q3z_1 = this.p3z_1;
      this.o3z_1 = element;
    }
    return result;
  }
  z2(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.am((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  h3() {
    this.n3z_1.h3();
    this.o3z_1 = null;
    this.p3z_1 = null;
    this.q3z_1 = null;
  }
}
class GenericSubList {
  constructor(base, start, end) {
    this.u3z_1 = base;
    this.v3z_1 = start;
    this.w3z_1 = end;
    var containsUpper = this.u3z_1.g1();
    var containsArg = this.v3z_1;
    if (!(0 <= containsArg ? containsArg <= containsUpper : false))
      throw IndexOutOfBoundsException.ze('' + this.v3z_1);
    var containsUpper_0 = this.u3z_1.g1();
    var containsArg_0 = this.w3z_1;
    if (!(0 <= containsArg_0 ? containsArg_0 <= containsUpper_0 : false))
      throw IndexOutOfBoundsException.ze('' + this.w3z_1);
  }
  g1() {
    return this.w3z_1 - this.v3z_1 | 0;
  }
  am(element) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var this_0 = until(0, this.g1());
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.j1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var inductionVariable = this_0.f2_1;
      var last = this_0.g2_1;
      if (inductionVariable <= last)
        do {
          var element_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.datastructure.GenericSubList.contains.<anonymous>' call
          var it = element_0;
          if (equals(this.h1(it), element)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
         while (!(element_0 === last));
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  z2(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.am((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  bm(elements) {
    var elementsSet = toMutableSet(elements);
    var inductionVariable = 0;
    var last = this.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.minusAssign' call
        var element = this.h1(n);
        elementsSet.g3(element);
      }
       while (inductionVariable < last);
    return elementsSet.j1();
  }
  a3(elements) {
    return this.bm(elements);
  }
  h1(index) {
    return this.u3z_1.h1(translateIndex(index, this));
  }
  j1() {
    return this.g1() === 0;
  }
  b1() {
    return new GenericListIterator(this);
  }
  b3() {
    return new GenericListIterator(this);
  }
  k1(index) {
    return new GenericListIterator(this, index);
  }
  q1(fromIndex, toIndex) {
    return new GenericSubList(this, fromIndex, toIndex);
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.g1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.f2_1;
    var last = this_0.g2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.GenericSubList.toString.<anonymous>' call
        var it = item;
        var tmp$ret$0 = this.h1(it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return toString(destination);
  }
  equals(other) {
    var tmp;
    if (other instanceof GenericSubList) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var count = this.g1();
        var inductionVariable = 0;
        if (inductionVariable < count)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.datastructure.GenericSubList.equals.<anonymous>' call
            if (!equals(this.h1(n), other.h1(n))) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < count);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = this.g1();
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.datastructure.GenericSubList.hashCode.<anonymous>' call
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.h1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        out = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class GenericListIterator {
  constructor(list, iindex) {
    iindex = iindex === VOID ? 0 : iindex;
    this.x3z_1 = list;
    this.y3z_1 = iindex;
    var containsUpper = this.x3z_1.g1();
    var containsArg = this.y3z_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      throw IndexOutOfBoundsException.ze('' + this.y3z_1);
    this.z3z_1 = this.y3z_1;
  }
  c1() {
    return this.z3z_1 < this.x3z_1.g1();
  }
  d1() {
    if (!this.c1())
      throw NoSuchElementException.x6();
    var _unary__edvuaz = this.z3z_1;
    this.z3z_1 = _unary__edvuaz + 1 | 0;
    return this.x3z_1.h1(_unary__edvuaz);
  }
  e7() {
    return this.z3z_1 > 0;
  }
  f7() {
    return this.z3z_1;
  }
  g7() {
    if (!this.e7())
      throw NoSuchElementException.x6();
    this.z3z_1 = this.z3z_1 - 1 | 0;
    return this.x3z_1.h1(this.z3z_1);
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof GenericListIterator) {
      tmp_0 = equals(this.x3z_1, other.x3z_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.z3z_1 === other.z3z_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.x3z_1) + this.z3z_1 | 0;
  }
}
class Companion_4 {
  h3u(width, height, arraySize) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(arraySize >= imul(width, height))) {
      // Inline function 'korlibs.datastructure.Companion.checkArraySize.<anonymous>' call
      var message = 'backing array of size=' + arraySize + ', has less elements than ' + width + ' * ' + height;
      throw IllegalStateException.h5(toString(message));
    }
  }
}
class Companion_5 {
  constructor() {
    this.q40_1 = 2147483646;
    this.r40_1 = 2147483647;
    this.s40_1 = 0;
  }
}
class Entry {
  constructor(key, value) {
    this.w40_1 = key;
    this.x40_1 = value;
  }
  toString() {
    return 'Entry(key=' + this.w40_1 + ', value=' + toString_0(this.x40_1) + ')';
  }
  hashCode() {
    var result = this.w40_1;
    result = imul(result, 31) + (this.x40_1 == null ? 0 : hashCode(this.x40_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!(this.w40_1 === tmp0_other_with_cast.w40_1))
      return false;
    if (!equals(this.x40_1, tmp0_other_with_cast.x40_1))
      return false;
    return true;
  }
}
class Iterator {
  constructor(map) {
    this.a40_1 = map;
    this.b40_1 = this.a40_1.g40_1 ? 2147483647 : nextNonEmptyIndex(this, this.a40_1.k40_1, 0);
    this.c40_1 = new Entry(0, null);
  }
  c1() {
    return !(this.b40_1 === 2147483646);
  }
  o40() {
    // Inline function 'kotlin.apply' call
    var this_0 = currentKey(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Iterator.nextKey.<anonymous>' call
    next(this);
    return this_0;
  }
  p40() {
    // Inline function 'kotlin.apply' call
    var this_0 = currentValue(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Iterator.nextValue.<anonymous>' call
    next(this);
    return this_0;
  }
}
class _no_name_provided__qut3iv {
  constructor(this$0) {
    this.y40_1 = this$0;
  }
  b1() {
    // Inline function 'korlibs.datastructure.IntMap.<get-keys>.<anonymous>' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntMap.<get-keys>.<anonymous>.<anonymous>' call
    var it = new Iterator(this.y40_1);
    var tmp = IntMap$_get_keys_$o$iterator$lambda_bn8atq(it);
    return Iterator_0(tmp, IntMap$_get_keys_$o$iterator$lambda_bn8atq_0(it));
  }
}
class _no_name_provided__qut3iv_0 {
  constructor(this$0) {
    this.z40_1 = this$0;
  }
  b1() {
    // Inline function 'korlibs.datastructure.IntMap.<get-values>.<anonymous>' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntMap.<get-values>.<anonymous>.<anonymous>' call
    var it = new Iterator(this.z40_1);
    var tmp = IntMap$_get_values_$o$iterator$lambda_ggo058(it);
    return Iterator_0(tmp, IntMap$_get_values_$o$iterator$lambda_ggo058_0(it));
  }
}
class IntMap {
  static t40(nbits, loadFactor, dummy) {
    dummy = dummy === VOID ? false : dummy;
    var $this = createThis(this);
    $this.d40_1 = nbits;
    $this.e40_1 = loadFactor;
    $this.f40_1 = 1 << $this.d40_1;
    $this.g40_1 = false;
    $this.h40_1 = null;
    $this.i40_1 = $this.f40_1 - 1 | 0;
    $this.j40_1 = 1 + imul($this.d40_1, $this.d40_1) | 0;
    $this.k40_1 = new Int32Array($this.v40());
    var tmp = $this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = $this.v40();
    var tmp_0 = fillArrayVal(Array(size), null);
    tmp.l40_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.m40_1 = numberToInt($this.f40_1 * $this.e40_1);
    $this.n40_1 = 0;
    return $this;
  }
  static a41(initialCapacity, loadFactor) {
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    // Inline function 'kotlin.math.max' call
    var b = ilog2Ceil(initialCapacity);
    var tmp$ret$0 = Math.max(4, b);
    return this.t40(tmp$ret$0, loadFactor, true);
  }
  v40() {
    return this.f40_1 + this.j40_1 | 0;
  }
  h1(key) {
    var index = _getKeyIndex(this, key);
    if (index < 0)
      return null;
    if (index === 2147483647)
      return this.h40_1;
    return this.l40_1[index];
  }
  u40(key, value) {
    retry: while (true) {
      var index = _getKeyIndex(this, key);
      if (index < 0) {
        if (key === 0) {
          this.g40_1 = true;
          this.h40_1 = value;
          this.n40_1 = this.n40_1 + 1 | 0;
          return null;
        }
        if (this.n40_1 >= this.m40_1) {
          grow(this);
        }
        var index1 = hash1(this, key);
        if (this.k40_1[index1] === 0)
          return setEmptySlot(this, index1, key, value);
        var index2 = hash2(this, key);
        if (this.k40_1[index2] === 0)
          return setEmptySlot(this, index2, key, value);
        var index3 = hash3(this, key);
        if (this.k40_1[index3] === 0)
          return setEmptySlot(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu(this);
        var last = this.k40_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.k40_1[n] === 0)
              return setEmptySlot(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.j40_1 > 512) {
          grow(this);
        } else {
          growStash(this);
        }
        continue retry;
      } else if (index === 2147483647) {
        // Inline function 'kotlin.apply' call
        var this_0 = this.h40_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntMap.set.<anonymous>' call
        this.h40_1 = value;
        return this_0;
      } else {
        // Inline function 'kotlin.apply' call
        var this_1 = this.l40_1[index];
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntMap.set.<anonymous>' call
        this.l40_1[index] = value;
        return this_1;
      }
    }
  }
  f3() {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv(this);
  }
  n3() {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv_0(this);
  }
  b41(keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last);
    return 2147483646;
  }
  equals(other) {
    if (!(other instanceof IntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.g40_1 ? 2147483647 : this.b41(this.k40_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.k40_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntMap.equals.<anonymous>' call
      var key = it;
      var value = this.h1(it);
      if (!equals(other.h1(key), value))
        return false;
      index = this.b41(this.k40_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return true;
  }
  hashCode() {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.g40_1 ? 2147483647 : this.b41(this.k40_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.k40_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntMap.hashCode.<anonymous>' call
      var tmp = out;
      var tmp_0 = it;
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver = this.h1(it);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      out = tmp + (tmp_0 + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0) | 0;
      index = this.b41(this.k40_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
  c41() {
    // Inline function 'korlibs.datastructure.IntMap.fastValueForEach' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.g40_1 ? 2147483647 : this.b41(this.k40_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntMap.fastValueForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.k40_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntMap.firstValue.<anonymous>' call
      return ensureNotNull(this.h1(it));
    }
    // Inline function 'kotlin.error' call
    var message = 'firstValue on empty IntMap';
    throw IllegalStateException.h5(toString(message));
  }
}
class Companion_6 {
  constructor() {
    this.d41_1 = 2147483646;
    this.e41_1 = 2147483647;
    this.f41_1 = 0;
  }
}
class IntIntMap {
  static r41(nbits, loadFactor, dummy) {
    var $this = createThis(this);
    $this.g41_1 = nbits;
    $this.h41_1 = loadFactor;
    $this.i41_1 = 1 << $this.g41_1;
    $this.j41_1 = false;
    $this.k41_1 = 0;
    $this.l41_1 = $this.i41_1 - 1 | 0;
    $this.m41_1 = 1 + imul($this.g41_1, $this.g41_1) | 0;
    $this.n41_1 = new Int32Array($this.v40());
    $this.o41_1 = new Int32Array($this.v40());
    $this.p41_1 = numberToInt($this.i41_1 * $this.h41_1);
    $this.q41_1 = 0;
    return $this;
  }
  static t41(initialCapacity, loadFactor) {
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    // Inline function 'kotlin.math.max' call
    var b = ilog2Ceil(initialCapacity);
    var tmp$ret$0 = Math.max(4, b);
    return this.r41(tmp$ret$0, loadFactor, true);
  }
  toString() {
    return toString(this.u41());
  }
  v40() {
    return this.i41_1 + this.m41_1 | 0;
  }
  v41(out) {
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.j41_1 ? 2147483647 : this.b41(this.n41_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.n41_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.toMap.<anonymous>' call
      var key = it;
      // Inline function 'kotlin.collections.set' call
      var value = this.h1(it);
      out.k3(key, value);
      index = this.b41(this.n41_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
  u41(out, $super) {
    out = out === VOID ? linkedHashMapOf([]) : out;
    return $super === VOID ? this.v41(out) : $super.v41.call(this, out);
  }
  hq(key) {
    return _getKeyIndex_0(this, key) >= 0;
  }
  h3() {
    this.j41_1 = false;
    this.k41_1 = 0;
    fill(this.n41_1, 0);
    fill(this.o41_1, 0);
    this.q41_1 = 0;
  }
  h1(key) {
    var index = _getKeyIndex_0(this, key);
    if (index < 0)
      return 0;
    if (index === 2147483647)
      return this.k41_1;
    return this.o41_1[index];
  }
  s41(key, value) {
    retry: while (true) {
      var index = _getKeyIndex_0(this, key);
      if (index < 0) {
        if (key === 0) {
          this.j41_1 = true;
          this.k41_1 = value;
          this.q41_1 = this.q41_1 + 1 | 0;
          return 0;
        }
        if (this.q41_1 >= this.p41_1) {
          grow_0(this);
        }
        var index1 = hash1_0(this, key);
        if (this.n41_1[index1] === 0)
          return setEmptySlot_0(this, index1, key, value);
        var index2 = hash2_0(this, key);
        if (this.n41_1[index2] === 0)
          return setEmptySlot_0(this, index2, key, value);
        var index3 = hash3_0(this, key);
        if (this.n41_1[index3] === 0)
          return setEmptySlot_0(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu_0(this);
        var last = this.n41_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.n41_1[n] === 0)
              return setEmptySlot_0(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.m41_1 > 512) {
          grow_0(this);
        } else {
          growStash_0(this);
        }
        continue retry;
      } else if (index === 2147483647) {
        // Inline function 'kotlin.apply' call
        var this_0 = this.k41_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntIntMap.set.<anonymous>' call
        this.k41_1 = value;
        return this_0;
      } else {
        // Inline function 'kotlin.apply' call
        var this_1 = this.o41_1[index];
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntIntMap.set.<anonymous>' call
        this.o41_1[index] = value;
        return this_1;
      }
    }
  }
  b41(keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last);
    return 2147483646;
  }
  equals(other) {
    if (!(other instanceof IntIntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.j41_1 ? 2147483647 : this.b41(this.n41_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.n41_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.equals.<anonymous>' call
      var key = it;
      var value = this.h1(it);
      if (!(other.h1(key) === value))
        return false;
      index = this.b41(this.n41_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return true;
  }
  hashCode() {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.j41_1 ? 2147483647 : this.b41(this.n41_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.n41_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.hashCode.<anonymous>' call
      out = out + (it + this.h1(it) | 0) | 0;
      index = this.b41(this.n41_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
}
class Iterator$1 {
  constructor($hasNext, $next) {
    this.w41_1 = $hasNext;
    this.x41_1 = $next;
  }
  c1() {
    return this.w41_1();
  }
  d1() {
    return this.x41_1();
  }
}
class Companion_7 {}
class Pool {
  static c42(reset, preallocate, gen) {
    var tmp;
    if (reset === VOID) {
      tmp = Pool$_init_$lambda_q3cbhr;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    var $this = createThis(this);
    $this.y41_1 = reset;
    $this.z41_1 = gen;
    $this.a42_1 = _TGenStack___init__impl__yynjgt();
    $this.b42_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < preallocate)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _unary__edvuaz = $this.b42_1;
        $this.b42_1 = _unary__edvuaz + 1 | 0;
        TGenStack__push_impl_9yh33t($this.a42_1, $this.z41_1(_unary__edvuaz));
      }
       while (inductionVariable < preallocate);
    return $this;
  }
  static d42(preallocate, gen) {
    preallocate = preallocate === VOID ? 0 : preallocate;
    return this.c42(Pool$_init_$lambda_q3cbhr_0, preallocate, gen);
  }
  e42() {
    return _TGenStack___get_size__impl__cvg66t(this.a42_1);
  }
  f42() {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(new TGenStack(this.a42_1)).j1()) {
      tmp = TGenStack__pop_impl_qisxa0(this.a42_1);
    } else {
      var _unary__edvuaz = this.b42_1;
      this.b42_1 = _unary__edvuaz + 1 | 0;
      tmp = this.z41_1(_unary__edvuaz);
    }
    return tmp;
  }
  h3() {
    TGenStack__clear_impl_pali4s(this.a42_1);
    this.b42_1 = 0;
  }
  g42(element) {
    this.y41_1(element);
    TGenStack__push_impl_9yh33t(this.a42_1, element);
  }
  h42(elements) {
    var _iterator__ex2g4s = elements.b1();
    while (_iterator__ex2g4s.c1()) {
      var element = _iterator__ex2g4s.d1();
      this.g42(element);
    }
  }
  hashCode() {
    return TGenStack__hashCode_impl_l04zom(this.a42_1);
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Pool) {
      tmp_0 = equals(this.a42_1, other.a42_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.e42() === other.e42();
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class ConcurrentPool extends Pool {
  static p42(reset, preallocate, gen) {
    var tmp;
    if (reset === VOID) {
      tmp = ConcurrentPool$_init_$lambda_gqhtk8;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    var $this = this.c42(reset, preallocate, gen);
    $this.m42_1 = reset;
    $this.n42_1 = gen;
    $this.o42_1 = new NonRecursiveLock();
    return $this;
  }
  f42() {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.o42_1.x35_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    // Inline function 'korlibs.datastructure.ConcurrentPool.alloc.<anonymous>' call
    return super.f42();
  }
  h3() {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.o42_1.x35_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    super.h3();
  }
  g42(element) {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.o42_1.x35_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    super.g42(element);
  }
}
class ReturnablePool {
  constructor(_reset, gen) {
    var tmp;
    if (_reset === VOID) {
      tmp = ReturnablePool$_init_$lambda_rsm60r;
    } else {
      tmp = _reset;
    }
    _reset = tmp;
    this.q42_1 = _reset;
    this.r42_1 = gen;
    this.s42_1 = fastArrayListOf([]);
    var tmp_0 = this;
    var tmp_1 = ReturnablePool$list$lambda(this);
    tmp_0.t42_1 = Pool.c42(tmp_1, VOID, ReturnablePool$list$lambda_0(this));
    this.u42_1 = this.t42_1.f42();
  }
  d1() {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.s42_1;
    var element = this.u42_1;
    this_0.h(element);
    this.u42_1 = this.t42_1.f42();
    return this.u42_1;
  }
  u1w() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.s42_1.s28_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.datastructure.ReturnablePool.reset.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[_unary__edvuaz];
      this.t42_1.g42(it);
    }
    this.s42_1.h3();
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.v42_1 = function_0;
  }
  vj(a, b) {
    return this.v42_1(a, b);
  }
  compare(a, b) {
    return this.vj(a, b);
  }
  o4() {
    return this.v42_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class Companion_8 {
  w42(comparator, reversed_0) {
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp = fillArrayVal(Array(16), null);
    return new TGenPriorityQueue(isArray(tmp) ? tmp : THROW_CCE(), reversed_0 ? reversed(comparator) : comparator);
  }
  x42(reversed, comparator) {
    return Companion_instance_9.w42(new sam$kotlin_Comparator$0(comparator), reversed);
  }
  y42(reversed, comparator, $super) {
    reversed = reversed === VOID ? false : reversed;
    return $super === VOID ? this.x42(reversed, comparator) : $super.x42.call(this, reversed, comparator);
  }
}
class TGenPriorityQueue$iterator$1 {
  constructor($index, this$0) {
    this.c43_1 = $index;
    this.d43_1 = this$0;
  }
  c1() {
    return this.c43_1._v < this.d43_1.b43_1;
  }
  d1() {
    var _unary__edvuaz = this.c43_1._v;
    this.c43_1._v = _unary__edvuaz + 1 | 0;
    return _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(_unary__edvuaz), this.d43_1);
  }
  f2l() {
    throw NotImplementedError.je();
  }
  t6() {
    return this.f2l();
  }
}
class TGenPriorityQueue {
  constructor(data, comparator) {
    this.z42_1 = data;
    this.a43_1 = comparator;
    this.b43_1 = 0;
  }
  g1() {
    return this.b43_1;
  }
  e43() {
    if (this.b43_1 <= 0)
      throw IndexOutOfBoundsException.ye();
    return this.z42_1[0];
  }
  p3y(element) {
    this.b43_1 = this.b43_1 + 1 | 0;
    ensure_0(this, this.b43_1);
    var i = _PriorityQueueNode___init__impl__34dlfu(this.b43_1 - 1 | 0);
    _set_value__lx0xdg(i, this, element);
    while (!_get_isRoot__1006zj(i, this) && gt(this, _get_value__a43j40(_get_parent__oo9xup(i, this), this), _get_value__a43j40(i, this))) {
      swap_0(this, i, _get_parent__oo9xup(i, this));
      i = _get_parent__oo9xup(i, this);
    }
    return true;
  }
  h(element) {
    return this.p3y((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  f43() {
    if (this.b43_1 <= 0)
      throw IndexOutOfBoundsException.ye();
    if (this.b43_1 === 1) {
      this.b43_1 = this.b43_1 - 1 | 0;
      return _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(0), this);
    }
    var root = _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(0), this);
    _set_value__lx0xdg(_PriorityQueueNode___init__impl__34dlfu(0), this, _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(this.b43_1 - 1 | 0), this));
    this.b43_1 = this.b43_1 - 1 | 0;
    minHeapify(this, 0);
    return root;
  }
  r3y(element) {
    var inductionVariable = 0;
    var last = this.b43_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.z42_1[n], element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  q3y(element) {
    var index = this.r3y(element);
    if (index >= 0) {
      this.l1s(index);
    }
    return index >= 0;
  }
  g3(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.q3y((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  l1s(index) {
    var i = _PriorityQueueNode___init__impl__34dlfu(index);
    while (!(_PriorityQueueNode___get_index__impl__b6r7i5(i) === 0)) {
      swap_0(this, i, _get_parent__oo9xup(i, this));
      i = _get_parent__oo9xup(i, this);
    }
    this.f43();
  }
  s3y(elements) {
    var thisSet = toSet(this);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.j1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'korlibs.datastructure.TGenPriorityQueue.containsAll.<anonymous>' call
        if (!thisSet.z2(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  a3(elements) {
    return this.s3y(elements);
  }
  j1() {
    return this.b43_1 === 0;
  }
  k3y(elements) {
    var _iterator__ex2g4s = elements.b1();
    while (_iterator__ex2g4s.c1()) {
      var e = _iterator__ex2g4s.d1();
      this.p3y(e);
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !elements.j1();
  }
  i1(elements) {
    return this.k3y(elements);
  }
  b1() {
    var index = {_v: 0};
    return new TGenPriorityQueue$iterator$1(index, this);
  }
  toString() {
    return toString(toList(this));
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof TGenPriorityQueue) {
      tmp_0 = contentEquals_1(this.z42_1, other.z42_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.a43_1, other.a43_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode_1(this.z42_1);
  }
}
class TGenQueue {
  constructor() {
    this.g43_1 = TGenDeque.g3y();
  }
  g1() {
    return this.g43_1.g1();
  }
  j1() {
    return this.g1() === 0;
  }
  h43(v) {
    this.g43_1.h3y(v);
  }
  i43() {
    return this.g43_1.ql();
  }
  s3y(elements) {
    return this.g43_1.s3y(elements);
  }
  a3(elements) {
    return this.s3y(elements);
  }
  b1() {
    return this.g43_1.b1();
  }
  hashCode() {
    return this.g43_1.hashCode();
  }
  equals(other) {
    var tmp;
    if (other instanceof TGenQueue) {
      tmp = this.g43_1.equals(other.g43_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class Ref$1 {
  j43(_set____db54di) {
    this.k43_1 = _set____db54di;
  }
  w1() {
    var tmp = this.k43_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('value');
    }
  }
}
class Ref$2 {
  constructor($prop) {
    this.l43_1 = $prop;
  }
  j43(value) {
    this.l43_1.set(value);
  }
  w1() {
    return this.l43_1.get();
  }
}
class ByteRingBuffer {
  constructor(bits) {
    this.b3v_1 = bits;
    this.c3v_1 = 1 << this.b3v_1;
    this.d3v_1 = this.c3v_1 - 1 | 0;
    this.e3v_1 = new Int8Array(this.c3v_1);
    this.f3v_1 = 0;
    this.g3v_1 = 0;
    this.h3v_1 = this.c3v_1;
    this.i3v_1 = 0;
  }
  c2e() {
    return this.e3v_1;
  }
  d2e() {
    return this.f3v_1 & this.d3v_1;
  }
  e2e() {
    return this.g3v_1 & this.d3v_1;
  }
  f2e(count) {
    if (count < 0 || count > this.h3v_1) {
      // Inline function 'kotlin.error' call
      var message = 'Try to write more than available';
      throw IllegalStateException.h5(toString(message));
    }
    this.g3v_1 = this.g3v_1 + count | 0;
    this.i3v_1 = this.i3v_1 + count | 0;
    this.h3v_1 = this.h3v_1 - count | 0;
  }
  g2e(count) {
    if (count < 0 || count > this.i3v_1) {
      // Inline function 'kotlin.error' call
      var message = 'Try to write more than available';
      throw IllegalStateException.h5(toString(message));
    }
    this.f3v_1 = this.f3v_1 + count | 0;
    this.i3v_1 = this.i3v_1 - count | 0;
    this.h3v_1 = this.h3v_1 + count | 0;
  }
  h2e() {
    // Inline function 'kotlin.math.min' call
    var a = this.i3v_1;
    var b = this.c3v_1 - (this.f3v_1 & this.d3v_1) | 0;
    return Math.min(a, b);
  }
  i2e() {
    // Inline function 'kotlin.math.min' call
    var a = this.h3v_1;
    var b = this.c3v_1 - (this.g3v_1 & this.d3v_1) | 0;
    return Math.min(a, b);
  }
  p3v(consume) {
    while (consume.i3v_1 > 0) {
      // Inline function 'kotlin.math.min' call
      var a = consume.h2e();
      var b = this.i2e();
      var copySize = Math.min(a, b);
      Memory_instance.m43(consume.c2e(), consume.d2e(), this.c2e(), this.e2e(), copySize);
      consume.g2e(copySize);
      this.f2e(copySize);
    }
  }
  v2d(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.h3v_1;
    var remaining = Math.min(a, size);
    var coffset = offset;
    var totalWrite = 0;
    $l$loop: while (remaining > 0) {
      // Inline function 'kotlin.math.min' call
      var a_0 = remaining;
      var b = this.i2e();
      var chunkSize = Math.min(a_0, b);
      if (chunkSize <= 0)
        break $l$loop;
      Memory_instance.m43(data, coffset, this.e3v_1, this.e2e(), chunkSize);
      this.f2e(chunkSize);
      coffset = coffset + chunkSize | 0;
      remaining = remaining - chunkSize | 0;
      totalWrite = totalWrite + chunkSize | 0;
    }
    return totalWrite;
  }
  k2e(size) {
    // Inline function 'kotlin.math.min' call
    var a = this.i3v_1;
    var toRead = Math.min(a, size);
    this.f3v_1 = (this.f3v_1 + toRead | 0) & this.d3v_1;
    this.h3v_1 = this.h3v_1 + toRead | 0;
    this.i3v_1 = this.i3v_1 - toRead | 0;
    return toRead;
  }
  j2e(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.i3v_1;
    var toRead = Math.min(a, size);
    var readCount = 0;
    var buffer = this.e3v_1;
    var mask = this.d3v_1;
    var coffset = offset;
    var lReadPos = this.f3v_1;
    $l$loop: while (true) {
      // Inline function 'kotlin.math.min' call
      var a_0 = toRead;
      var b = this.h2e();
      var toReadChunk = Math.min(a_0, b);
      if (toReadChunk <= 0)
        break $l$loop;
      Memory_instance.m43(buffer, lReadPos & mask, data, coffset, toReadChunk);
      toRead = toRead - toReadChunk | 0;
      coffset = coffset + toReadChunk | 0;
      lReadPos = lReadPos + toReadChunk | 0;
      readCount = readCount + toReadChunk | 0;
    }
    return readCount;
  }
  h3() {
    this.f3v_1 = 0;
    this.g3v_1 = 0;
    this.i3v_1 = 0;
    this.h3v_1 = this.c3v_1;
  }
  m2e(offset) {
    return this.e3v_1[(this.f3v_1 + offset | 0) & this.d3v_1];
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof ByteRingBuffer) {
      tmp_0 = this.i3v_1 === other.i3v_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var count = this.i3v_1;
        var inductionVariable = 0;
        if (inductionVariable < count)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.datastructure.ByteRingBuffer.equals.<anonymous>' call
            if (!(this.m2e(n) === other.m2e(n))) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < count);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.x2d();
  }
  x2d() {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = this.i3v_1;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.datastructure.ByteRingBuffer.contentHashCode.<anonymous>' call
        out = tmp + this.m2e(n) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class RingBuffer extends ByteRingBuffer {}
class ShortRingBuffer {
  constructor(bits) {
    this.r3v_1 = bits;
    this.s3v_1 = 1 << this.r3v_1;
    this.t3v_1 = this.s3v_1 - 1 | 0;
    this.u3v_1 = new Int16Array(this.s3v_1);
    this.v3v_1 = 0;
    this.w3v_1 = 0;
    this.x3v_1 = this.s3v_1;
    this.y3v_1 = 0;
    this.z3v_1 = new Int16Array(1);
  }
  g3w(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.x3v_1;
    var toWrite = Math.min(a, size);
    var inductionVariable = 0;
    if (inductionVariable < toWrite)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.u3v_1[this.w3v_1] = data[offset + n | 0];
        this.w3v_1 = (this.w3v_1 + 1 | 0) & this.t3v_1;
      }
       while (inductionVariable < toWrite);
    this.y3v_1 = this.y3v_1 + toWrite | 0;
    this.x3v_1 = this.x3v_1 - toWrite | 0;
    return toWrite;
  }
  f3w(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.y3v_1;
    var toRead = Math.min(a, size);
    var inductionVariable = 0;
    if (inductionVariable < toRead)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        data[offset + n | 0] = this.u3v_1[this.v3v_1];
        this.v3v_1 = (this.v3v_1 + 1 | 0) & this.t3v_1;
      }
       while (inductionVariable < toRead);
    this.x3v_1 = this.x3v_1 + toRead | 0;
    this.y3v_1 = this.y3v_1 - toRead | 0;
    return toRead;
  }
  h3() {
    this.v3v_1 = 0;
    this.w3v_1 = 0;
    this.y3v_1 = 0;
    this.x3v_1 = this.s3v_1;
  }
  m2e(offset) {
    return this.u3v_1[(this.v3v_1 + offset | 0) & this.t3v_1];
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof ShortRingBuffer) {
      tmp_0 = this.y3v_1 === other.y3v_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var count = this.y3v_1;
        var inductionVariable = 0;
        if (inductionVariable < count)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.datastructure.ShortRingBuffer.equals.<anonymous>' call
            if (!(this.m2e(n) === other.m2e(n))) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < count);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.x2d();
  }
  x2d() {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = this.y3v_1;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.datastructure.ShortRingBuffer.contentHashCode.<anonymous>' call
        out = tmp + this.m2e(n) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class Companion_9 {}
class TGenStack {
  constructor(items) {
    this.n43_1 = items;
  }
  g1() {
    return _TGenStack___get_size__impl__cvg66t(this.n43_1);
  }
  j1() {
    return TGenStack__isEmpty_impl_bsbpyi(this.n43_1);
  }
  s3y(elements) {
    return TGenStack__containsAll_impl_ic9i7r(this.n43_1, elements);
  }
  a3(elements) {
    return TGenStack__containsAll_impl_ic9i7r_0(this, elements);
  }
  b1() {
    return TGenStack__iterator_impl_2pdia5(this.n43_1);
  }
  toString() {
    return TGenStack__toString_impl_s9t5hn(this.n43_1);
  }
  hashCode() {
    return TGenStack__hashCode_impl_l04zom(this.n43_1);
  }
  equals(other) {
    return TGenStack__equals_impl_w9i35u(this.n43_1, other);
  }
}
class IStackedArray2Base {}
function get_endX() {
  return this.p43() + this.f3u() | 0;
}
function get_endY() {
  return this.q43() + this.g3u() | 0;
}
function inside_0(x, y) {
  return x >= 0 && y >= 0 && x < this.f3u() && y < this.g3u();
}
class BaseDelegatedStackedArray2 {
  static w43(other) {
    var $this = createThis(this);
    $this.v43_1 = other;
    return $this;
  }
  n3u(x, y) {
    return this.v43_1.n3u(x, y);
  }
  o43() {
    return this.v43_1.o43();
  }
  p43() {
    return this.v43_1.p43();
  }
  q43() {
    return this.v43_1.q43();
  }
  f3u() {
    return this.v43_1.f3u();
  }
  g3u() {
    return this.v43_1.g3u();
  }
  r43() {
    return this.v43_1.r43();
  }
  s43() {
    return this.v43_1.s43();
  }
  t43() {
    return this.v43_1.t43();
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_11 = this;
    this.x43_1 = Companion_getInstance().t26_1;
  }
}
class StackedInt53Array2 {
  constructor(width, height, empty, startX, startY) {
    Companion_getInstance_11();
    empty = empty === VOID ? Companion_getInstance_11().x43_1 : empty;
    startX = startX === VOID ? 0 : startX;
    startY = startY === VOID ? 0 : startY;
    this.y43_1 = width;
    this.z43_1 = height;
    this.a44_1 = empty;
    this.b44_1 = startX;
    this.c44_1 = startY;
    this.d44_1 = 0;
    var tmp = this;
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width_0 = this.y43_1;
    var height_0 = this.z43_1;
    var tmp_0 = 0;
    var tmp_1 = imul(width_0, height_0);
    var tmp_2 = new Int32Array(tmp_1);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = 0;
      tmp_0 = tmp_0 + 1 | 0;
    }
    var tmp_3 = tmp_2;
    tmp.e44_1 = new IntArray2(width_0, height_0, isIntArray(tmp_3) ? tmp_3 : THROW_CCE());
    this.f44_1 = fastArrayListOf([]);
  }
  f3u() {
    return this.y43_1;
  }
  g3u() {
    return this.z43_1;
  }
  p43() {
    return this.b44_1;
  }
  q43() {
    return this.c44_1;
  }
  o43() {
    return this.d44_1;
  }
  toString() {
    return 'StackedInt53Array2((' + this.y43_1 + ', ' + this.z43_1 + '), empty=' + Int53__toString_impl_j0waj0(this.a44_1) + ', startXY=(' + this.b44_1 + ',' + this.c44_1 + '))';
  }
  r43() {
    return this.f44_1.g1();
  }
  g44(level) {
    while (level >= this.f44_1.g1()) {
      // Inline function 'korlibs.datastructure.Companion.invoke' call
      var width = this.y43_1;
      var height = this.z43_1;
      var fill = this.a44_1;
      // Inline function 'korlibs.number.Companion.invoke' call
      var tmp = 0;
      var tmp_0 = imul(width, height);
      var tmp_1 = new Float64Array(tmp_0);
      while (tmp < tmp_0) {
        // Inline function 'korlibs.datastructure.Companion.invoke.<anonymous>' call
        tmp_1[tmp] = _Int53___get_value__impl__ww0yo(fill);
        tmp = tmp + 1 | 0;
      }
      var tmp_2 = _Int53Array___init__impl__gn3wej(tmp_1);
      var tmp$ret$3 = new Int53Array2(width, height, new Int53Array(tmp_2) instanceof Int53Array ? tmp_2 : THROW_CCE());
      this.f44_1.h(tmp$ret$3);
    }
  }
  h44(x, y, level, value) {
    if (!this.n3u(x, y))
      return Unit_instance;
    this.g44(level);
    this.f44_1.h1(level).z3u(x, y, value);
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = this.e44_1.z3k(x, y);
    var b = level + 1 | 0;
    var tmp$ret$0 = Math.max(a, b);
    this.e44_1.l3u(x, y, tmp$ret$0);
    this.d44_1 = this.d44_1 + 1 | 0;
  }
  i44(x, y, level) {
    if (!this.n3u(x, y))
      return this.a44_1;
    if (level > this.e44_1.z3k(x, y))
      return this.a44_1;
    return this.f44_1.h1(level).y3u(x, y);
  }
  u43(x, y) {
    if (!this.n3u(x, y))
      return 0;
    return this.e44_1.z3k(x, y);
  }
}
class SyncPauseable {
  constructor() {
    this.j44_1 = new Lock();
    this.k44_1 = false;
  }
  l44(value) {
    if (!(this.k44_1 === value)) {
      this.k44_1 = value;
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var this_0 = this.j44_1;
      $l$block: {
        // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
        this_0.c36();
        try {
          this.j44_1.g36();
          break $l$block;
        }finally {
          this_0.e36();
        }
      }
    }
  }
}
class Memory {
  b3y(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var destination = isArray(dst) ? dst : THROW_CCE();
    var endIndex = srcPos + size | 0;
    arrayCopy(src, destination, dstPos, srcPos, endIndex);
  }
  m43(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
  v3w(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
  o3x(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
}
class PointList {}
function get_dimensions() {
  return 2;
}
function isEmpty() {
  return this.g1() === 0;
}
function getX(index) {
  return this.z3k(index, 0);
}
function getY(index) {
  return this.z3k(index, 1);
}
function get_2(index) {
  return Vector2D.y3k(this.z3k(index, 0), this.z3k(index, 1));
}
function getComponentList(component, out) {
  var inductionVariable = 0;
  var last = this.g1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out[n] = this.z3k(n, component);
    }
     while (inductionVariable < last);
  return out;
}
function getComponentList$default(component, out, $super) {
  out = out === VOID ? new Float64Array(this.g1()) : out;
  return $super === VOID ? this.m44(component, out) : getComponentList(component, out);
}
function get_first() {
  return this.h1(0);
}
function get_last() {
  return this.h1(this.g1() - 1 | 0);
}
function contains(p) {
  return this.v3q(p.r3i_1, p.s3i_1);
}
function contains_0(x, y) {
  var inductionVariable = 0;
  var last = this.g1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (this.w3k(n) === x && this.x3k(n) === y)
        return true;
    }
     while (inductionVariable < last);
  return false;
}
function clone(out) {
  out.s44(this);
  return out;
}
function clone$default(out, $super) {
  out = out === VOID ? new PointArrayList(this.g1()) : out;
  return $super === VOID ? this.o44(out) : clone(out);
}
class Companion_11 {}
class PointArrayList {
  constructor(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.p44_1 = new Mixin();
    this.q44_1 = false;
    this.r44_1 = DoubleArrayList.f3x(imul(capacity, 2));
  }
  c28(_set____db54di) {
    this.p44_1.c28(_set____db54di);
  }
  d28() {
    return this.p44_1.d28();
  }
  g1() {
    return this.r44_1.g1() / 2 | 0;
  }
  z3k(index_0, dim) {
    return this.r44_1.x27(index(this, index_0, dim));
  }
  w3k(index_0) {
    return this.r44_1.x27(index(this, index_0, 0));
  }
  x3k(index_0) {
    return this.r44_1.x27(index(this, index_0, 1));
  }
  h1(index_0) {
    var i = index(this, index_0, 0);
    return Vector2D.y3k(this.r44_1.x27(i), this.r44_1.x27(i + 1 | 0));
  }
  ai() {
    this.r44_1.h3();
    return this;
  }
  u44(x, y) {
    this.r44_1.i3x(x, y);
    return this;
  }
  v44(p) {
    return this.u44(p.r3i_1, p.s3i_1);
  }
  w44(p) {
    return this.x44(p);
  }
  x44(p) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.PointArrayList.addAll.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < p.g1()) {
      // Inline function 'korlibs.math.geom.PointArrayList.addAll.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var destruct = p.h1(_unary__edvuaz);
      var x = destruct.em();
      var y = destruct.fm();
      this.u44(x, y);
    }
    return this;
  }
  y44(p, index) {
    this.u44(p.w3k(index), p.x3k(index));
  }
  s44(other) {
    this.ai();
    this.w44(other);
    return this;
  }
  o44(out) {
    return out.ai().w44(this);
  }
  b3x(index_0, count) {
    this.r44_1.b3x(index(this, index_0, 0), imul(count, 2));
    return this;
  }
  z44(index, count, $super) {
    count = count === VOID ? 1 : count;
    return $super === VOID ? this.b3x(index, count) : $super.b3x.call(this, index, count);
  }
  equals(other) {
    var tmp;
    if (other instanceof PointArrayList) {
      tmp = this.r44_1.equals(other.r44_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.r44_1.hashCode();
  }
  toString() {
    var sb = StringBuilder.f();
    sb.hc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _destruct__k2r9zo = this.h1(n);
        var x = _destruct__k2r9zo.em();
        var y = _destruct__k2r9zo.fm();
        if (!(n === 0)) {
          sb.gc(', ');
        }
        sb.hc(_Char___init__impl__6a9atx(40));
        if (x === round(x))
          sb.rh(numberToInt(x));
        else
          sb.uh(x);
        sb.gc(', ');
        if (y === round(y))
          sb.rh(numberToInt(y));
        else
          sb.uh(y);
        sb.hc(_Char___init__impl__6a9atx(41));
      }
       while (inductionVariable < last);
    sb.hc(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
  z2(element) {
    if (!(element instanceof Vector2D))
      return false;
    return this.v3k(element instanceof Vector2D ? element : THROW_CCE());
  }
  f27(other, epsilon) {
    return this.a3l((!(other == null) ? isInterface(other, IDoubleVectorList) : false) ? other : THROW_CCE(), epsilon);
  }
  a3(elements) {
    return this.t3k(elements);
  }
}
class Companion_12 {}
class PointIntArrayList {
  constructor(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.a45_1 = new Mixin();
    this.b45_1 = false;
    this.c45_1 = IntArrayList.l3w(capacity);
    this.d45_1 = IntArrayList.l3w(capacity);
  }
  c28(_set____db54di) {
    this.a45_1.c28(_set____db54di);
  }
  d28() {
    return this.a45_1.d28();
  }
  g1() {
    return this.c45_1.g1();
  }
  j1() {
    return this.g1() === 0;
  }
  h3() {
    this.c45_1.h3();
    this.d45_1.h3();
  }
  e45(x, y) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.PointIntArrayList.add.<anonymous>' call
    this.c45_1.s3w(x);
    this.d45_1.s3w(y);
    return this;
  }
  f45(p) {
    return this.e45(p.s3r_1, p.t3r_1);
  }
  w3k(index) {
    return this.c45_1.x27(index);
  }
  x3k(index) {
    return this.d45_1.x27(index);
  }
  toString() {
    var sb = StringBuilder.f();
    sb.hc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var x = this.w3k(n);
        var y = this.x3k(n);
        if (!(n === 0)) {
          sb.gc(', ');
        }
        sb.hc(_Char___init__impl__6a9atx(40));
        sb.rh(x);
        sb.gc(', ');
        sb.rh(y);
        sb.hc(_Char___init__impl__6a9atx(41));
      }
       while (inductionVariable < last);
    sb.hc(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
//endregion
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
function ensureWrite($this, count) {
  if (count <= $this.l3v_1.h3v_1)
    return Unit_instance;
  if (!$this.k3v_1) {
    var message = "Can't grow ByteArrayDeque. Need to write " + count + ', but only ' + $this.l3v_1.h3v_1 + ' is available';
    println('ERROR: ' + message);
    // Inline function 'kotlin.error' call
    throw IllegalStateException.h5(toString(message));
  }
  var minNewSize = $this.l3v_1.i3v_1 + count | 0;
  var tmp = $this;
  // Inline function 'kotlin.also' call
  var this_0 = new RingBuffer(ilog2(minNewSize) + 2 | 0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.ByteArrayDeque.ensureWrite.<anonymous>' call
  this_0.p3v($this.l3v_1);
  tmp.l3v_1 = this_0;
}
function ensureWrite_0($this, count) {
  if (count > $this.b3w_1.x3v_1) {
    var minNewSize = $this.b3w_1.y3v_1 + count | 0;
    var newBits = ilog2(minNewSize) + 2 | 0;
    var newRing = new ShortRingBuffer(newBits);
    while ($this.b3w_1.y3v_1 > 0) {
      var read = $this.b3w_1.f3w($this.c3w_1, 0, $this.c3w_1.length);
      newRing.g3w($this.c3w_1, 0, read);
    }
    $this.b3w_1 = newRing;
  }
  return $this;
}
function swap(_this__u8e3s4, lIndex, rIndex) {
  var temp = _this__u8e3s4[lIndex];
  _this__u8e3s4[lIndex] = _this__u8e3s4[rIndex];
  _this__u8e3s4[rIndex] = temp;
}
function rotateRight(_this__u8e3s4, offset) {
  offset = offset === VOID ? 1 : offset;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure._rotateRight' call
    var size = _this__u8e3s4.length;
    var offset_0 = umod(offset, size);
    if (offset_0 === 0) {
      tmp$ret$0 = Unit_instance;
      break $l$block;
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(1 <= offset_0 ? offset_0 < size : false)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.h5(toString(message));
    }
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, 0, size);
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, 0, offset_0);
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, offset_0, size);
  }
  return tmp$ret$0;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
function ensure($this, count) {
  if (($this.e3x_1 + count | 0) > $this.d3x_1.length) {
    var tmp = $this;
    var tmp_0 = $this.d3x_1;
    // Inline function 'kotlin.math.max' call
    var a = $this.e3x_1 + count | 0;
    var b = imul($this.d3x_1.length, 3);
    var tmp$ret$0 = Math.max(a, b);
    var tmp_1 = copyOf_0(tmp_0, tmp$ret$0);
    tmp.d3x_1 = isDoubleArray(tmp_1) ? tmp_1 : THROW_CCE();
  }
}
function intArrayListOf(values) {
  return IntArrayList.p3w(values.slice());
}
function toIntArrayList(_this__u8e3s4) {
  return IntArrayList.p3w(_this__u8e3s4.slice());
}
function sort(_this__u8e3s4, start, end, reversed) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.g1() : end;
  reversed = reversed === VOID ? false : reversed;
  return genericSort_0(_this__u8e3s4, start, end - 1 | 0, DoubleArrayListSortOps_getInstance(), reversed);
}
function reverse_0(_this__u8e3s4, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.g1() : end;
  return DoubleArrayListSortOps_getInstance().s3x(_this__u8e3s4, start, end - 1 | 0);
}
var DoubleArrayListSortOps_instance;
function DoubleArrayListSortOps_getInstance() {
  if (DoubleArrayListSortOps_instance === VOID)
    new DoubleArrayListSortOps();
  return DoubleArrayListSortOps_instance;
}
function _get__data__kyoi3c($this) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return $this.a3y_1;
}
function _get_capacity__a9k9f3($this) {
  return $this.a3y_1.length;
}
function resizeIfRequiredFor($this, count) {
  if (($this.g1() + count | 0) > _get_capacity__a9k9f3($this)) {
    var i = $this.a3y_1;
    var istart = $this.y3x_1;
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = $this.a3y_1.length + 7 | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = $this.g1() + count | 0;
    var b = imul($this.a3y_1.length, 2);
    var b_0 = Math.max(a_0, b);
    var size = Math.max(a, b_0);
    var _o = fillArrayVal(Array(size), null);
    var o = isArray(_o) ? _o : THROW_CCE();
    copyCyclic($this, i, istart, o, $this.z3x_1);
    $this.a3y_1 = o;
    $this.y3x_1 = 0;
  }
}
function copyCyclic($this, i, istart, o, count) {
  // Inline function 'kotlin.math.min' call
  var a = i.length - istart | 0;
  var size1 = Math.min(a, count);
  var size2 = count - size1 | 0;
  Memory_instance.b3y(i, istart, o, 0, size1);
  if (size2 > 0) {
    Memory_instance.b3y(i, 0, o, size1, size2);
  }
}
function _addLast($this, item) {
  $this.a3y_1[($this.y3x_1 + $this.z3x_1 | 0) % _get_capacity__a9k9f3($this) | 0] = item;
  $this.z3x_1 = $this.z3x_1 + 1 | 0;
}
function nullify($this, index) {
  _get__data__kyoi3c($this)[index] = null;
}
function internalIndex($this, index) {
  return umod($this.y3x_1 + index | 0, _get_capacity__a9k9f3($this));
}
function _get__data__kyoi3c_0($this) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return $this.v3y_1;
}
function _get_capacity__a9k9f3_0($this) {
  return $this.v3y_1.length;
}
function resizeIfRequiredFor_0($this, count) {
  if (($this.g1() + count | 0) > _get_capacity__a9k9f3_0($this)) {
    var i = $this.v3y_1;
    var istart = $this.t3y_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = $this.v3y_1.length + 7 | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = $this.g1() + count | 0;
    var b = imul($this.v3y_1.length, 2);
    var b_0 = Math.max(a_0, b);
    var tmp$ret$1 = Math.max(a, b_0);
    var _o = new Int32Array(tmp$ret$1);
    var o = isIntArray(_o) ? _o : THROW_CCE();
    copyCyclic_0($this, i, istart, o, $this.u3y_1);
    $this.v3y_1 = o;
    $this.t3y_1 = 0;
  }
}
function copyCyclic_0($this, i, istart, o, count) {
  // Inline function 'kotlin.math.min' call
  var a = i.length - istart | 0;
  var size1 = Math.min(a, count);
  var size2 = count - size1 | 0;
  Memory_instance.v3w(i, istart, o, 0, size1);
  if (size2 > 0) {
    Memory_instance.v3w(i, 0, o, size1, size2);
  }
}
function _addLast_0($this, item) {
  $this.v3y_1[($this.t3y_1 + $this.u3y_1 | 0) % _get_capacity__a9k9f3_0($this) | 0] = item;
  $this.u3y_1 = $this.u3y_1 + 1 | 0;
}
function nullify_0($this, index) {
  _get__data__kyoi3c_0($this)[index] = 0;
}
function internalIndex_0($this, index) {
  return umod($this.t3y_1 + index | 0, _get_capacity__a9k9f3_0($this));
}
function toDeque(_this__u8e3s4) {
  return Deque(_this__u8e3s4);
}
function Deque(other) {
  // Inline function 'kotlin.also' call
  var this_0 = TGenDeque.f3y(other.g1());
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.Deque.<anonymous>' call
  this_0.k3y(other);
  return this_0;
}
function getAndRemove(_this__u8e3s4, key) {
  // Inline function 'kotlin.also' call
  var this_0 = get_3(_this__u8e3s4, key);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.getAndRemove.<anonymous>' call
  remove(_this__u8e3s4, key);
  return this_0;
}
function get_keys(_this__u8e3s4) {
  return keys(_this__u8e3s4);
}
function toLinkedMap(_this__u8e3s4) {
  var out = linkedHashMapOf([]);
  // Inline function 'korlibs.datastructure.fastForEachNullable' call
  // Inline function 'korlibs.datastructure.fastKeyForEach' call
  // Inline function 'kotlin.js.asDynamic' call
  var mapIterator = _this__u8e3s4.keys();
  $l$loop: while (true) {
    var v = mapIterator.next();
    if (v.done)
      break $l$loop;
    // Inline function 'korlibs.datastructure.fastForEachNullable.<anonymous>' call
    var it = v.value;
    // Inline function 'korlibs.datastructure.toLinkedMap.<anonymous>' call
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var value = _this__u8e3s4.get(it);
    if (!(value == null)) {
      // Inline function 'kotlin.collections.set' call
      out.k3(it, value);
    }
  }
  return out;
}
function translateIndex(_this__u8e3s4, $this) {
  if (!(0 <= _this__u8e3s4 ? _this__u8e3s4 < $this.g1() : false))
    throw IndexOutOfBoundsException.ze('' + _this__u8e3s4);
  return $this.v3z_1 + _this__u8e3s4 | 0;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
function IArray2$asString$lambda(this$0) {
  return function (y) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this$0.f3u());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.f2_1;
    var last = this_0.g2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.IArray2.asString.<anonymous>.<anonymous>' call
        var x = item;
        var tmp$ret$0 = this$0.m3u(x, y);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return joinToString(destination, ', ');
  };
}
function indexOr(_this__u8e3s4, x, y, invalid) {
  invalid = invalid === VOID ? -1 : invalid;
  if (!(0 <= x ? x < _this__u8e3s4.f3u() : false) || !(0 <= y ? y < _this__u8e3s4.g3u() : false))
    return invalid;
  return imul(y, _this__u8e3s4.f3u()) + x | 0;
}
function currentKey($this) {
  switch ($this.b40_1) {
    case 2147483647:
    case 2147483646:
      return 0;
    default:
      return $this.a40_1.k40_1[$this.b40_1];
  }
}
function currentValue($this) {
  switch ($this.b40_1) {
    case 2147483647:
      return $this.a40_1.h40_1;
    case 2147483646:
      return null;
    default:
      return $this.a40_1.l40_1[$this.b40_1];
  }
}
function nextNonEmptyIndex($this, keys, offset) {
  var inductionVariable = offset;
  var last = keys.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(keys[n] === 0))
        return n;
    }
     while (inductionVariable < last);
  return 2147483646;
}
function next($this) {
  if (!($this.b40_1 === 2147483646))
    $this.b40_1 = nextNonEmptyIndex($this, $this.a40_1.k40_1, $this.b40_1 === 2147483647 ? 0 : $this.b40_1 + 1 | 0);
}
function IntMap$_get_keys_$o$iterator$lambda_bn8atq($it) {
  return function () {
    return $it.c1();
  };
}
function IntMap$_get_keys_$o$iterator$lambda_bn8atq_0($it) {
  return function () {
    return $it.o40();
  };
}
function IntMap$_get_values_$o$iterator$lambda_ggo058($it) {
  return function () {
    return $it.c1();
  };
}
function IntMap$_get_values_$o$iterator$lambda_ggo058_0($it) {
  return function () {
    return $it.p40();
  };
}
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
function _get_stashStart__3psegu($this) {
  return $this.k40_1.length - $this.j40_1 | 0;
}
function grow($this) {
  var inc = $this.d40_1 < 20 ? 3 : 1;
  var newnbits = $this.d40_1 + inc | 0;
  var new_0 = IntMap.t40(newnbits, $this.e40_1, true);
  var inductionVariable = 0;
  var last = $this.k40_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var k = $this.k40_1[n];
      if (!(k === 0)) {
        new_0.u40(k, $this.l40_1[n]);
      }
    }
     while (inductionVariable <= last);
  $this.d40_1 = new_0.d40_1;
  $this.f40_1 = new_0.f40_1;
  $this.i40_1 = new_0.i40_1;
  $this.j40_1 = new_0.j40_1;
  $this.k40_1 = new_0.k40_1;
  $this.l40_1 = new_0.l40_1;
  $this.m40_1 = new_0.m40_1;
}
function growStash($this) {
  $this.j40_1 = imul($this.j40_1, 2);
  $this.k40_1 = copyOf($this.k40_1, $this.v40());
  $this.l40_1 = copyOf_1($this.l40_1, $this.v40());
}
function _getKeyIndex($this, key) {
  if (key === 0)
    return $this.g40_1 ? 2147483647 : -1;
  var index1 = hash1($this, key);
  if ($this.k40_1[index1] === key)
    return index1;
  var index2 = hash2($this, key);
  if ($this.k40_1[index2] === key)
    return index2;
  var index3 = hash3($this, key);
  if ($this.k40_1[index3] === key)
    return index3;
  var inductionVariable = _get_stashStart__3psegu($this);
  var last = $this.k40_1.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if ($this.k40_1[n] === key)
        return n;
    }
     while (inductionVariable < last);
  return -1;
}
function setEmptySlot($this, index, key, value) {
  if (!($this.k40_1[index] === 0))
    throw IllegalStateException.y5();
  $this.k40_1[index] = key;
  $this.l40_1[index] = value;
  $this.n40_1 = $this.n40_1 + 1 | 0;
  return null;
}
function hash1($this, key) {
  return _hash1(key, $this.i40_1);
}
function hash2($this, key) {
  return _hash2(key, $this.i40_1);
}
function hash3($this, key) {
  return _hash3(key, $this.i40_1);
}
var Companion_instance_7;
function Companion_getInstance_7() {
  return Companion_instance_7;
}
function _get_stashStart__3psegu_0($this) {
  return $this.n41_1.length - $this.m41_1 | 0;
}
function grow_0($this) {
  var inc = $this.g41_1 < 20 ? 3 : 1;
  var newnbits = $this.g41_1 + inc | 0;
  var new_0 = IntIntMap.r41(newnbits, $this.h41_1, true);
  var inductionVariable = 0;
  var last = $this.n41_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var k = $this.n41_1[n];
      if (!(k === 0)) {
        new_0.s41(k, $this.o41_1[n]);
      }
    }
     while (inductionVariable <= last);
  $this.g41_1 = new_0.g41_1;
  $this.i41_1 = new_0.i41_1;
  $this.l41_1 = new_0.l41_1;
  $this.m41_1 = new_0.m41_1;
  $this.n41_1 = new_0.n41_1;
  $this.o41_1 = new_0.o41_1;
  $this.p41_1 = new_0.p41_1;
}
function growStash_0($this) {
  $this.m41_1 = imul($this.m41_1, 2);
  $this.n41_1 = copyOf($this.n41_1, $this.v40());
  $this.o41_1 = copyOf($this.o41_1, $this.v40());
}
function _getKeyIndex_0($this, key) {
  if (key === 0)
    return $this.j41_1 ? 2147483647 : -1;
  var index1 = hash1_0($this, key);
  if ($this.n41_1[index1] === key)
    return index1;
  var index2 = hash2_0($this, key);
  if ($this.n41_1[index2] === key)
    return index2;
  var index3 = hash3_0($this, key);
  if ($this.n41_1[index3] === key)
    return index3;
  var inductionVariable = _get_stashStart__3psegu_0($this);
  var last = $this.n41_1.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if ($this.n41_1[n] === key)
        return n;
    }
     while (inductionVariable < last);
  return -1;
}
function setEmptySlot_0($this, index, key, value) {
  if (!($this.n41_1[index] === 0))
    throw IllegalStateException.y5();
  $this.n41_1[index] = key;
  $this.o41_1[index] = value;
  $this.q41_1 = $this.q41_1 + 1 | 0;
  return 0;
}
function hash1_0($this, key) {
  return _hash1(key, $this.l41_1);
}
function hash2_0($this, key) {
  return _hash2(key, $this.l41_1);
}
function hash3_0($this, key) {
  return _hash3(key, $this.l41_1);
}
function toIntMap(_this__u8e3s4) {
  var out = IntMap.a41(numberToInt(_this__u8e3s4.g1() * 1.25));
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = _this__u8e3s4.u1().b1();
  while (_iterator__ex2g4s.c1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.d1();
    // Inline function 'kotlin.collections.component1' call
    var k = _destruct__k2r9zo.v1();
    // Inline function 'kotlin.collections.component2' call
    var v = _destruct__k2r9zo.w1();
    out.u40(k, v);
  }
  return out;
}
function _hash1(key, mask) {
  return _mask(key, mask);
}
function _hash2(key, mask) {
  return _mask(imul(key, 1294968109), mask);
}
function _hash3(key, mask) {
  return _mask(imul(key, 294969449), mask);
}
function _mask(value, mask) {
  return (((value + ((value >>> 8 | 0) & 255) | 0) + ((value >>> 16 | 0) & 255) | 0) + (value >> 24 & 255) | 0) & mask;
}
function associateByInt(_this__u8e3s4, block) {
  var n = 0;
  var out = IntMap.a41();
  var _iterator__ex2g4s = _this__u8e3s4.b1();
  while (_iterator__ex2g4s.c1()) {
    var it = _iterator__ex2g4s.d1();
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    out.u40(block(_unary__edvuaz, it), it);
  }
  return out;
}
function Iterator_0(hasNext, next) {
  return new Iterator$1(hasNext, next);
}
var Companion_instance_8;
function Companion_getInstance_8() {
  return Companion_instance_8;
}
function Pool$_init_$lambda_q3cbhr(it) {
  return Unit_instance;
}
function Pool$_init_$lambda_q3cbhr_0(it) {
  return Unit_instance;
}
function ConcurrentPool$_init_$lambda_gqhtk8(it) {
  return Unit_instance;
}
function ReturnablePool$_init_$lambda_rsm60r(it) {
  return Unit_instance;
}
function ReturnablePool$list$lambda(this$0) {
  return function (it) {
    this$0.q42_1(it);
    return Unit_instance;
  };
}
function ReturnablePool$list$lambda_0(this$0) {
  return function (it) {
    return this$0.r42_1(it);
  };
}
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
function _set_value__lx0xdg(_this__u8e3s4, $this, value) {
  $this.z42_1[_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)] = value;
}
function _get_value__a43j40(_this__u8e3s4, $this) {
  return $this.z42_1[_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)];
}
function _get_isRoot__1006zj(_this__u8e3s4, $this) {
  return _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4) === 0;
}
function _get_parent__oo9xup(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu((_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4) - 1 | 0) / 2 | 0);
}
function _get_left__d9qyp0(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu(imul(2, _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)) + 1 | 0);
}
function _get_right__bvz45n(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu(imul(2, _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)) + 2 | 0);
}
function gt($this, a, b) {
  return $this.a43_1.compare(a, b) > 0;
}
function lt($this, a, b) {
  return $this.a43_1.compare(a, b) < 0;
}
function _get_capacity__a9k9f3_1($this) {
  return $this.z42_1.length;
}
function ensure_0($this, index) {
  if (index >= _get_capacity__a9k9f3_1($this)) {
    var tmp = $this;
    var tmp_0 = copyOf_1($this.z42_1, 2 + imul(_get_capacity__a9k9f3_1($this), 2) | 0);
    tmp.z42_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
  }
}
function minHeapify($this, index) {
  var i = _PriorityQueueNode___init__impl__34dlfu(index);
  $l$loop: while (true) {
    var left = _get_left__d9qyp0(i, $this);
    var right = _get_right__bvz45n(i, $this);
    var smallest = i;
    if (_PriorityQueueNode___get_index__impl__b6r7i5(left) < $this.b43_1 && lt($this, _get_value__a43j40(left, $this), _get_value__a43j40(i, $this)))
      smallest = left;
    if (_PriorityQueueNode___get_index__impl__b6r7i5(right) < $this.b43_1 && lt($this, _get_value__a43j40(right, $this), _get_value__a43j40(smallest, $this)))
      smallest = right;
    if (!(smallest === i)) {
      swap_0($this, i, smallest);
      i = smallest;
    } else {
      break $l$loop;
    }
  }
}
function swap_0($this, l, r) {
  var temp = _get_value__a43j40(r, $this);
  _set_value__lx0xdg(r, $this, _get_value__a43j40(l, $this));
  _set_value__lx0xdg(l, $this, temp);
}
function _PriorityQueueNode___init__impl__34dlfu(index) {
  return index;
}
function _PriorityQueueNode___get_index__impl__b6r7i5($this) {
  return $this;
}
function Ref(value) {
  // Inline function 'kotlin.also' call
  var this_0 = Ref_0();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.Ref.<anonymous>' call
  this_0.j43(value);
  return this_0;
}
function toRef(_this__u8e3s4) {
  return Ref_1(_this__u8e3s4);
}
function Ref_0() {
  return new Ref$1();
}
function Ref_1(prop) {
  return new Ref$2(prop);
}
function _TGenStack___init__impl__yynjgt(items) {
  items = items === VOID ? FastArrayList.u28() : items;
  return items;
}
function _get_items__fzd5gv($this) {
  return $this;
}
function _TGenStack___get_size__impl__cvg66t($this) {
  return _get_items__fzd5gv($this).g1();
}
function TGenStack__isEmpty_impl_bsbpyi($this) {
  return _TGenStack___get_size__impl__cvg66t($this) === 0;
}
var Companion_instance_10;
function Companion_getInstance_10() {
  return Companion_instance_10;
}
function TGenStack__push_impl_9yh33t($this, v) {
  _get_items__fzd5gv($this).h(v);
}
function TGenStack__pop_impl_qisxa0($this) {
  return _get_items__fzd5gv($this).j3(_get_items__fzd5gv($this).g1() - 1 | 0);
}
function TGenStack__clear_impl_pali4s($this) {
  _get_items__fzd5gv($this).h3();
}
function TGenStack__containsAll_impl_ic9i7r($this, elements) {
  return _get_items__fzd5gv($this).a3(elements);
}
function TGenStack__containsAll_impl_ic9i7r_0($this, elements) {
  return TGenStack__containsAll_impl_ic9i7r($this.n43_1, elements);
}
function TGenStack__iterator_impl_2pdia5($this) {
  return _get_items__fzd5gv($this).b1();
}
function TGenStack__toString_impl_s9t5hn($this) {
  return 'TGenStack(items=' + $this.toString() + ')';
}
function TGenStack__hashCode_impl_l04zom($this) {
  return $this.hashCode();
}
function TGenStack__equals_impl_w9i35u($this, other) {
  if (!(other instanceof TGenStack))
    return false;
  var tmp0_other_with_cast = other instanceof TGenStack ? other.n43_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
var Companion_instance_11;
function Companion_getInstance_11() {
  if (Companion_instance_11 === VOID)
    new Companion_10();
  return Companion_instance_11;
}
function contentHashCode_3(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + _this__u8e3s4[src + n | 0] | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_3(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var count = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < count);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function contentHashCode_4(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + numberToInt(_this__u8e3s4[src + n | 0]) | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_4(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var count = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < count);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function fill(_this__u8e3s4, value) {
  var inductionVariable = 0;
  var last = _this__u8e3s4.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      _this__u8e3s4[n] = value;
    }
     while (inductionVariable <= last);
}
function linkedHashMapOf(pairs) {
  // Inline function 'kotlin.also' call
  var this_0 = LinkedHashMap.wc();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.linkedHashMapOf.<anonymous>' call
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var _destruct__k2r9zo = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var key = _destruct__k2r9zo.em();
    var value = _destruct__k2r9zo.fm();
    // Inline function 'kotlin.collections.set' call
    this_0.k3(key, value);
  }
  return this_0;
}
function _BSearchResult___init__impl__em6zam(raw) {
  return raw;
}
function _BSearchResult___get_raw__impl__uyuhf3($this) {
  return $this;
}
function _BSearchResult___get_found__impl__om04iz($this) {
  return _BSearchResult___get_raw__impl__uyuhf3($this) >= 0;
}
function _BSearchResult___get_index__impl__b5kraz($this) {
  return _BSearchResult___get_found__impl__om04iz($this) ? _BSearchResult___get_raw__impl__uyuhf3($this) : -1;
}
function _BSearchResult___get_nearIndex__impl__s8nq43($this) {
  return _BSearchResult___get_found__impl__om04iz($this) ? _BSearchResult___get_raw__impl__uyuhf3($this) : (-_BSearchResult___get_raw__impl__uyuhf3($this) | 0) - 1 | 0;
}
function binarySearch(_this__u8e3s4, v, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? _this__u8e3s4.g1() : toIndex;
  // Inline function 'korlibs.datastructure.genericBinarySearchResult' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.genericBinarySearch' call
    var low = fromIndex;
    var high = toIndex - 1 | 0;
    while (low <= high) {
      var mid = (low + high | 0) / 2 | 0;
      // Inline function 'korlibs.datastructure.binarySearch.<anonymous>' call
      var mval = compareTo(_this__u8e3s4.x27(mid), v);
      if (mval < 0)
        low = mid + 1 | 0;
      else if (mval > 0)
        high = mid - 1 | 0;
      else {
        tmp$ret$1 = mid;
        break $l$block;
      }
    }
    // Inline function 'korlibs.datastructure.genericBinarySearchResult.<anonymous>' call
    tmp$ret$1 = (-low | 0) - 1 | 0;
  }
  return _BSearchResult___init__impl__em6zam(tmp$ret$1);
}
function getCyclic(_this__u8e3s4, index) {
  return _this__u8e3s4.h1(umod(index, _this__u8e3s4.g1()));
}
function getCyclicOrNull(_this__u8e3s4, index) {
  return _this__u8e3s4.j1() ? null : getOrNull(_this__u8e3s4, umod(index, _this__u8e3s4.g1()));
}
function toLinkedMap_0(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = LinkedHashMap.wc();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.toLinkedMap.<anonymous>' call
  var _iterator__ex2g4s = _this__u8e3s4.b1();
  while (_iterator__ex2g4s.c1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.d1();
    var key = _destruct__k2r9zo.em();
    var value = _destruct__k2r9zo.fm();
    // Inline function 'kotlin.collections.set' call
    this_0.k3(key, value);
  }
  return this_0;
}
function getCyclic_0(_this__u8e3s4, index) {
  return _this__u8e3s4[umod(index, _this__u8e3s4.length)];
}
function genericSort(subject, left, right, ops) {
  return genericSort_0(subject, left, right, ops, false);
}
function genericSort_0(subject, left, right, ops, reversed) {
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.genericSort.<anonymous>' call
  timSort(subject, left, right, ops, reversed);
  return subject;
}
function timSort(arr, l, r, ops, reversed, RUN) {
  RUN = RUN === VOID ? 32 : RUN;
  var n = (r - l | 0) + 1 | 0;
  var progression = step(until(0, n), RUN);
  var inductionVariable = progression.f2_1;
  var last = progression.g2_1;
  var step_0 = progression.h2_1;
  if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + step_0 | 0;
      var tmp = l + i | 0;
      // Inline function 'kotlin.math.min' call
      var a = (i + RUN | 0) - 1 | 0;
      var b = n - 1 | 0;
      var tmp$ret$0 = Math.min(a, b);
      insertionSort(arr, tmp, l + tmp$ret$0 | 0, ops, reversed);
    }
     while (!(i === last));
  var size = RUN;
  while (size < n) {
    var progression_0 = step(until(0, n), imul(2, size));
    var inductionVariable_0 = progression_0.f2_1;
    var last_0 = progression_0.g2_1;
    var step_1 = progression_0.h2_1;
    if (step_1 > 0 && inductionVariable_0 <= last_0 || (step_1 < 0 && last_0 <= inductionVariable_0))
      do {
        var left = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + step_1 | 0;
        // Inline function 'kotlin.math.min' call
        var a_0 = size;
        var b_0 = (n - left | 0) - 1 | 0;
        var rize = Math.min(a_0, b_0);
        var mid = (left + rize | 0) - 1 | 0;
        // Inline function 'kotlin.math.min' call
        var a_1 = (left + imul(2, rize) | 0) - 1 | 0;
        var b_1 = n - 1 | 0;
        var right = Math.min(a_1, b_1);
        merge(arr, l + left | 0, l + mid | 0, l + right | 0, ops, reversed);
      }
       while (!(left === last_0));
    size = imul(size, 2);
  }
}
function insertionSort(arr, left, right, ops, reversed) {
  var inductionVariable = left + 1 | 0;
  if (inductionVariable <= right)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var m = n - 1 | 0;
      $l$loop: while (m >= left && negateIf(ops.u3x(arr, m, n), reversed) > 0) {
        m = m - 1 | 0;
      }
      m = m + 1 | 0;
      if (!(m === n)) {
        ops.x3x(arr, m, n);
      }
    }
     while (!(n === right));
}
function merge(arr, start, mid, end, ops, reversed) {
  var s = start;
  var m = mid;
  var s2 = m + 1 | 0;
  if (negateIf(ops.u3x(arr, m, s2), reversed) <= 0)
    return Unit_instance;
  while (s <= m && s2 <= end) {
    if (negateIf(ops.u3x(arr, s, s2), reversed) <= 0) {
      s = s + 1 | 0;
    } else {
      ops.x3x(arr, s, s2);
      s = s + 1 | 0;
      m = m + 1 | 0;
      s2 = s2 + 1 | 0;
    }
  }
}
function negateIf(_this__u8e3s4, doNegate) {
  return doNegate ? -_this__u8e3s4 | 0 : _this__u8e3s4;
}
var Memory_instance;
function Memory_getInstance() {
  return Memory_instance;
}
var Companion_instance_12;
function Companion_getInstance_12() {
  return Companion_instance_12;
}
function index($this, index, offset) {
  return imul(index, 2) + offset | 0;
}
function pointArrayListOf(p0, p1) {
  return (new PointArrayList(2)).v44(p0).v44(p1);
}
function pointArrayListOf_0(p0, p1, p2) {
  return (new PointArrayList(3)).v44(p0).v44(p1).v44(p2);
}
function pointArrayListOf_1(p0, p1, p2, p3) {
  return (new PointArrayList(4)).v44(p0).v44(p1).v44(p2).v44(p3);
}
var Companion_instance_13;
function Companion_getInstance_13() {
  return Companion_instance_13;
}
function FastStringMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function FastIntMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function get_size(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.size;
}
function FastIdentityMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function contains_1(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.has(key);
}
function clear(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.clear();
}
function get_size_0(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.size;
}
function get_3(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.get(key);
}
function set_2(_this__u8e3s4, key, value) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.set(key, value);
}
function remove(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.delete(key);
}
function keys(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = Array_from(_this__u8e3s4.keys());
  return toList_0(tmp$ret$2);
}
function Array_from(value) {
  return Array.from(value);
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForInterface(IArray2, 'IArray2', VOID, VOID, [Iterable]);
initMetadataForInterface(IntIArray2, 'IntIArray2', VOID, VOID, [IArray2]);
protoOf(IntArray2).z3k = get;
protoOf(IntArray2).l3u = set;
protoOf(IntArray2).x27 = getAt_0;
protoOf(IntArray2).m3u = getAt;
protoOf(IntArray2).n3u = inside;
protoOf(IntArray2).k3u = asString;
initMetadataForClass(IntArray2, 'IntArray2', VOID, VOID, [IntIArray2]);
initMetadataForCompanion(Companion_0);
initMetadataForInterface(FloatIArray2, 'FloatIArray2', VOID, VOID, [IArray2]);
protoOf(FloatArray2).z3k = get_0;
protoOf(FloatArray2).s3u = set_0;
protoOf(FloatArray2).x27 = getAt_1;
protoOf(FloatArray2).m3u = getAt;
protoOf(FloatArray2).n3u = inside;
protoOf(FloatArray2).k3u = asString;
initMetadataForClass(FloatArray2, 'FloatArray2', VOID, VOID, [FloatIArray2]);
initMetadataForCompanion(Companion_1);
initMetadataForInterface(Int53IArray2, 'Int53IArray2', VOID, VOID, [IArray2]);
protoOf(Int53Array2).y3u = get_1;
protoOf(Int53Array2).z3u = set_1;
protoOf(Int53Array2).a3v = getAt_2;
protoOf(Int53Array2).m3u = getAt;
protoOf(Int53Array2).n3u = inside;
protoOf(Int53Array2).k3u = asString;
initMetadataForClass(Int53Array2, 'Int53Array2', VOID, VOID, [Int53IArray2]);
initMetadataForClass(ByteArrayDeque, 'ByteArrayDeque', ByteArrayDeque);
initMetadataForClass(ShortArrayDeque, 'ShortArrayDeque', ShortArrayDeque);
initMetadataForCompanion(Companion_2);
initMetadataForClass(IntArrayList, 'IntArrayList', IntArrayList.l3w, VOID, [Collection]);
initMetadataForCompanion(Companion_3);
protoOf(DoubleArrayList).b3 = listIterator;
initMetadataForClass(DoubleArrayList, 'DoubleArrayList', DoubleArrayList.f3x, VOID, [DoubleList]);
initMetadataForClass(SortOps, 'SortOps');
initMetadataForObject(DoubleArrayListSortOps, 'DoubleArrayListSortOps');
initMetadataForClass(TGenDeque$iterator$1);
initMetadataForClass(TGenDeque, 'TGenDeque', TGenDeque.g3y, VOID, [MutableIterable, Collection]);
initMetadataForClass(IntDeque$iterator$1);
initMetadataForClass(IntDeque, 'IntDeque', IntDeque.a3z, VOID, [MutableIterable, Collection]);
initMetadataForClass(FastIdentityCacheMap, 'FastIdentityCacheMap', FastIdentityCacheMap);
initMetadataForClass(FastSmallSet, 'FastSmallSet', FastSmallSet.r3z);
initMetadataForClass(GenericSubList, 'GenericSubList', VOID, VOID, [KtList]);
initMetadataForClass(GenericListIterator, 'GenericListIterator');
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(Entry, 'Entry');
initMetadataForClass(Iterator, 'Iterator');
initMetadataForClass(_no_name_provided__qut3iv, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(_no_name_provided__qut3iv_0, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(IntMap, 'IntMap', IntMap.a41);
initMetadataForCompanion(Companion_6);
initMetadataForClass(IntIntMap, 'IntIntMap', IntIntMap.t41);
initMetadataForClass(Iterator$1);
initMetadataForCompanion(Companion_7);
initMetadataForClass(Pool, 'Pool');
initMetadataForClass(ConcurrentPool, 'ConcurrentPool');
initMetadataForClass(ReturnablePool, 'ReturnablePool');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(TGenPriorityQueue$iterator$1);
initMetadataForClass(TGenPriorityQueue, 'TGenPriorityQueue', VOID, VOID, [MutableIterable, Collection]);
initMetadataForClass(TGenQueue, 'TGenQueue', TGenQueue, VOID, [Collection]);
initMetadataForClass(Ref$1);
initMetadataForClass(Ref$2);
initMetadataForClass(ByteRingBuffer, 'ByteRingBuffer');
initMetadataForClass(RingBuffer, 'RingBuffer');
initMetadataForClass(ShortRingBuffer, 'ShortRingBuffer');
initMetadataForCompanion(Companion_9);
initMetadataForClass(TGenStack, 'TGenStack', VOID, VOID, [Collection]);
initMetadataForInterface(IStackedArray2Base, 'IStackedArray2Base');
initMetadataForClass(BaseDelegatedStackedArray2, 'BaseDelegatedStackedArray2', VOID, VOID, [IStackedArray2Base]);
initMetadataForCompanion(Companion_10);
protoOf(StackedInt53Array2).s43 = get_endX;
protoOf(StackedInt53Array2).t43 = get_endY;
protoOf(StackedInt53Array2).n3u = inside_0;
initMetadataForClass(StackedInt53Array2, 'StackedInt53Array2', VOID, VOID, [IStackedArray2Base]);
initMetadataForClass(SyncPauseable, 'SyncPauseable', SyncPauseable);
initMetadataForObject(Memory, 'Memory');
initMetadataForInterface(PointList, 'PointList', VOID, VOID, [IDoubleVectorList, IPointList]);
initMetadataForCompanion(Companion_11);
protoOf(PointArrayList).t44 = clone$default;
protoOf(PointArrayList).b3l = get_dimensions;
protoOf(PointArrayList).j1 = isEmpty;
protoOf(PointArrayList).m44 = getComponentList;
protoOf(PointArrayList).n44 = getComponentList$default;
protoOf(PointArrayList).m3y = get_first;
protoOf(PointArrayList).n3y = get_last;
protoOf(PointArrayList).v3k = contains;
protoOf(PointArrayList).v3q = contains_0;
protoOf(PointArrayList).a3l = isAlmostEquals;
protoOf(PointArrayList).g27 = isAlmostEquals$default;
protoOf(PointArrayList).t3k = containsAll;
protoOf(PointArrayList).b1 = iterator;
protoOf(PointArrayList).b3 = listIterator_0;
protoOf(PointArrayList).k1 = listIterator_1;
protoOf(PointArrayList).q1 = subList;
initMetadataForClass(PointArrayList, 'PointArrayList', PointArrayList, VOID, [PointList]);
initMetadataForCompanion(Companion_12);
initMetadataForClass(PointIntArrayList, 'PointIntArrayList', PointIntArrayList);
//endregion
//region block: init
Companion_instance_0 = new Companion();
Companion_instance_1 = new Companion_0();
Companion_instance_2 = new Companion_1();
Companion_instance_3 = new Companion_2();
Companion_instance_4 = new Companion_3();
Companion_instance_5 = new Companion_4();
Companion_instance_6 = new Companion_5();
Companion_instance_7 = new Companion_6();
Companion_instance_8 = new Companion_7();
Companion_instance_9 = new Companion_8();
Companion_instance_10 = new Companion_9();
Memory_instance = new Memory();
Companion_instance_12 = new Companion_11();
Companion_instance_13 = new Companion_12();
//endregion
//region block: exports
export {
  _BSearchResult___init__impl__em6zam as _BSearchResult___init__impl__em6zam3kgjdixysmohf,
  _BSearchResult___get_found__impl__om04iz as _BSearchResult___get_found__impl__om04iz3bh6o9yjop0o,
  _BSearchResult___get_index__impl__b5kraz as _BSearchResult___get_index__impl__b5kraz2d2rlh08ytgci,
  _BSearchResult___get_nearIndex__impl__s8nq43 as _BSearchResult___get_nearIndex__impl__s8nq431w00iur5bsqs2,
  _TGenStack___init__impl__yynjgt as _TGenStack___init__impl__yynjgt2kqnbzr6sil9y,
  TGenStack__pop_impl_qisxa0 as TGenStack__pop_impl_qisxa01c9hqlgdxaps5,
  TGenStack__push_impl_9yh33t as TGenStack__push_impl_9yh33t21dxxdiycat5m,
  Companion_instance_1 as Companion_instance3ldriv9x4zcjm,
  Companion_instance_0 as Companion_instancelqpzd9anuk16,
  Companion_instance_9 as Companion_instance2r8kc48nhvjcq,
  SyncPauseable as SyncPauseable20rt0nt3umu2s,
  BaseDelegatedStackedArray2 as BaseDelegatedStackedArray2i6xcy52y4r2o,
  ByteArrayDeque as ByteArrayDeque2dezgzzyyl6zm,
  ConcurrentPool as ConcurrentPool3ky1e4r5za9ab,
  DoubleArrayList as DoubleArrayList3by0we6lhx26x,
  FastIdentityCacheMap as FastIdentityCacheMap3fegd59qa1ixp,
  FastIdentityMap as FastIdentityMap17d14y8i3m5g7,
  FastIntMap as FastIntMapl0pzyavg6uw5,
  FastSmallSet as FastSmallSet2og2j8v2pz4c7,
  FastStringMap as FastStringMap1l1uzdhsfbatm,
  FloatArray2 as FloatArray2beehiaucxmzd,
  GenericListIterator as GenericListIterator397gjg9p2xwl5,
  GenericSubList as GenericSubList2rec7qqyf06nw,
  IStackedArray2Base as IStackedArray2Baseutd8qm80cz0q,
  IntArray2 as IntArray23680o40e0fgt8,
  IntArrayList as IntArrayList3liuagbdnwmna,
  IntDeque as IntDeque2ebok66x2sofm,
  IntIntMap as IntIntMap3mvg5iqgd5t3z,
  IntMap as IntMap2d9g6f5pyaoc2,
  Pool as Pool1zbsw0zhvh8ca,
  Ref_0 as Ref11k43t82thcp3,
  Ref as Ref2y4j4snnxo6gs,
  ReturnablePool as ReturnablePool3rkgvxsckx2u2,
  ShortArrayDeque as ShortArrayDeque13dn2tr6asm80,
  SortOps as SortOps3rp25tm4jbjru,
  StackedInt53Array2 as StackedInt53Array22b4kxb7j3a5rc,
  TGenDeque as TGenDeque2zx9g0ftfbw19,
  TGenQueue as TGenQueue2v9j3ju90xgpv,
  associateByInt as associateByInt3vmv30txx5avl,
  binarySearch as binarySearch1lxbagta5e4q4,
  clear as clear3idbm40uzyume,
  contains_1 as containsrsn76oa0puwr,
  genericSort as genericSort3vhmyxbppxo3h,
  getAndRemove as getAndRemove1ksxnnren48mb,
  getCyclicOrNull as getCyclicOrNull12fem85bj0m7u,
  getCyclic_0 as getCyclic18d9063nmuul,
  getCyclic as getCyclic28wvgqye98jqx,
  get_3 as get2pw1zlgv5zypd,
  intArrayListOf as intArrayListOf18h0hna7wb0zr,
  get_keys as get_keyswqddktl7cnu2,
  linkedHashMapOf as linkedHashMapOf2w2uhgrq4khrk,
  reverse_0 as reverse22fe0u1pwl2c6,
  rotateRight as rotateRight96vk8nw2c6nx,
  set_2 as set2vuztm9k7ubgo,
  get_size_0 as get_size2tttv7g2u748n,
  get_size as get_size3oaoh8cpamcqc,
  sort as sort23bpsawysis6n,
  swap as swap3upf401qn4fc8,
  toDeque as toDeque2gx2crptp8sro,
  toIntArrayList as toIntArrayList3jlt4o6tyleu,
  toIntMap as toIntMapp1jij98esrcm,
  toLinkedMap as toLinkedMap37vdtde5j2z8d,
  toRef as toRef3av6zm8yavumw,
  PointArrayList as PointArrayList281mrsgyr6ua1,
  PointIntArrayList as PointIntArrayList1s7gare9hr1oh,
  pointArrayListOf_1 as pointArrayListOf36sb9r6prgwk4,
  pointArrayListOf_0 as pointArrayListOf2s9je3njyg83l,
  pointArrayListOf as pointArrayListOf7rbgdbqf3x4b,
};
//endregion
